/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  createDynamicColumn,
  createPassPort,
  createProductSpec,
  deletePassport,
  editPassport,
  getAcn,
  getDppDocumentsImage,
  getDynamicColumn,
  getIndustryType,
  getItemMaster,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getManufacturerDetails,
  getOpenBinsByWarehouseAndZone,
  getParentDppCode,
  getParentRawCodes,
  getPassPort,
  getProductSpecification,
  getProductVariant,
  getRelationLocation,
  getSubModulesByRoleId,
  getViewDataByDppId,
  getWarehouses,
  getWarehousesByMovement,
  getZonesByWarehouse,
  uploadCsvForItemMapping,
  uploadCsvForPassport,
  uploadCsvForProductPassportChild,
  uploadForUrl,
} from "../../../store";

// Cookies
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import UploadButton from "components/standardized-components/UploadButton";
import ViewButton from "components/standardized-components/ViewButton";
import { format } from "date-fns";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
  // overflowX: "hide",
};
const styleForStationModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1100,
  boxShadow: 24,
  p: 1,
  pt: 3,
  maxHeight: "90vh",
  overflowY: "auto",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Passport = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  dppIdSelectedForGlobalFilter,
  createDynamicColumn,
  getWarehouses,
  deletePassport,
  warehouses,
  getPassPort,
  getPassPortReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editPassport,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createPassPort,
  getWarehousesByMovement,
  uploadCsvForItemMapping,
  getLevelsByWarehouse,
  uploadForUrl,
  getParentDppCodesReducer,
  getDppDocumentsImage,
  getParentDppCode,
  getParentRawCodes,
  getViewDataByDppId,
  getDynamicColumnReducer,
  getDppDocumentsImageReducer,
  getPassPortViewReducer,
  getParentRawCodesReducer,
  getProductVariant,
  getProductVariantReducer,
  getManufacturerDetails,
  getManufacturerDetailsReducer,
  getIndustryTypeReducer,
  getIndustryType,
  createProductSpec,
  getProductSpecification,
  getProductSpecificationReducer,
  uploadCsvForPassport,
  uploadCsvForProductPassportChild,
  getDPPReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  //  useEffect(() => {
  //     getParentDppCode(jwtToken);
  //   }, []);
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState(null);
  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "14087f18-c281-4ed7-9f1a-c1b627b50f8e",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "43e15b1f-5d71-4617-a711-7cd86dabafc9",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "c5adf5a5-8c52-41f4-a5bd-43c0134785a5",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "5bba8215-c9fa-4823-a4a1-0843ea43b035",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "b6d01d2c-3bc7-44ed-ad06-bb49759e08ff",
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const [isSuccessAllocateItemPS, setIsSuccessAllocateItemPS] = useState(false);
  const [isErrorAllocateItemPS, setIsErrorAllocateItemPS] = useState(false);

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const [ParentDppIdSelected, setParentDppIdSelected] = useState("");
  const [RawDppSelected, setRawDppSelected] = useState("");

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleChangeDppCodeParent = (selectedData) => {
    setParentDppIdSelected(selectedData);
  };
  const handleChangeDppCodeRaw = (selectedData) => {
    setRawDppSelected(selectedData);
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  useEffect(() => {
    getManufacturerDetails(jwtToken);
  }, []);
  useEffect(() => {
    getIndustryType(jwtToken);
  }, []);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [openPSModal, setOpenPSModal] = useState(false);
  const [selectedItemForPS, setSelectedItemForPS] = useState(null);

  const handleOpenPSModal = (item) => {
    setSelectedItemForPS(item);
    setOpenPSModal(true);
  };

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
        industryName: zone.industryName,
        industryId: zone.industryId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  // setdppIdForUpdateSelected({
  //   label: singleData.dppCode,
  //   value: singleData.dppId,
  //   industryId: singleData.industryId,
  // });

  const handleClosePSModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenPSModal(false);
    formikPS.resetForm();
  };

  useEffect(() => {
    if (isSuccessAllocateItemPS) {
      setTimeout(() => {
        setIsSuccessAllocateItemPS(false);
      }, 3000);
    }
  }, [isSuccessAllocateItemPS]);

  useEffect(() => {
    if (isErrorAllocateItemPS) {
      setTimeout(() => {
        setIsErrorAllocateItemPS(false);
      }, 3000);
    }
  }, [isErrorAllocateItemPS]);

  const actualMassUOMOptions = [
    { value: "kg", label: "kg (Kilogram)" },
    { value: "g", label: "g (Gram)" },
    { value: "mg", label: "mg (Milligram)" },
    { value: "t", label: "t (Metric Tonne)" },
  ];

  const quantityUOMOptions = [
    { value: "kg", label: "kg (Kilogram)" },
    { value: "NOS", label: "NOS (Numbers)" },
    { value: "L", label: "L (Litre)" },
    { value: "g", label: "g (Gram)" },
    { value: "EA", label: "EA (Each)" },
    { value: "PCS", label: "PCS (Pieces)" },
  ];

  const ratedCapacityUnitOptions = [
    { label: "Ah (Ampere-hours)", value: "Ah" },
    { label: "mAh (Milliampere-hours)", value: "mAh" },
  ];
  const nominalVoltageUnitOptions = [{ label: "V (Volts)", value: "V" }];
  const powerRatingUnitOptions = [
    { label: "W (Watts)", value: "W" },
    { label: "kW (Kilowatts)", value: "kW" },
  ];
  const energyDensityUnitOptions = [
    { label: "Wh/kg (Watt-hours per kilogram)", value: "Wh/kg" },
  ];
  const batteryChemistryOptions = [
    { label: "Li-ion (Lithium-ion)", value: "Li-ion" },
    { label: "LFP (Lithium Iron Phosphate)", value: "LFP" },
    { label: "NMC (Nickel Manganese Cobalt)", value: "NMC" },
  ];
  const batteryCellFormatOptions = [
    { label: "Cylindrical", value: "Cylindrical" },
    { label: "Prismatic", value: "Prismatic" },
    { label: "Pouch", value: "Pouch" },
  ];
  const batteryDimensionsUnitOptions = [
    { label: "mm (Millimeters)", value: "mm" },
    { label: "cm (Centimeters)", value: "cm" },
    { label: "m (Meters)", value: "m" },
  ];

  const ceMarkingOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const positiveNumberRegex = /^\d+(\.\d+)?$/;
  const positiveNumberMsg = "Only positive integer or decimal values allowed";

  const initialValuesPS = {
    ratedCapacity: "",
    ratedCapacityUnit: null,
    nominalVoltage: "",
    nominalVoltageUnit: null,
    powerRating: "",
    powerRatingUnit: null,
    energyDensity: "",
    energyDensityUnit: null,
    batteryChemistry: null,
    batteryCellFormat: null,
    dimensionLength: "",
    dimensionWidth: "",
    dimensionHeight: "",
    batteryDimensionsUnit: null,
  };

  const validationSchemaPS = Yup.object({
    ratedCapacity: Yup.string()
      .matches(positiveNumberRegex, positiveNumberMsg)
      .required(" "),
    ratedCapacityUnit: Yup.object().nullable().required(" "),

    nominalVoltage: Yup.string()
      .matches(positiveNumberRegex, positiveNumberMsg)
      .required(" "),
    nominalVoltageUnit: Yup.object().nullable().required(" "),

    powerRating: Yup.string()
      .matches(positiveNumberRegex, positiveNumberMsg)
      .required(" "),
    powerRatingUnit: Yup.object().nullable().required(" "),

    energyDensity: Yup.string()
      .matches(positiveNumberRegex, positiveNumberMsg)
      .required(" "),
    energyDensityUnit: Yup.object().nullable().required(" "),

    batteryChemistry: Yup.object().nullable().required(" "),
    batteryCellFormat: Yup.object().nullable().required(" "),

    dimensionLength: Yup.string()
      .matches(positiveNumberRegex, positiveNumberMsg)
      .required(" "),
    dimensionWidth: Yup.string()
      .matches(positiveNumberRegex, positiveNumberMsg)
      .required(" "),
    dimensionHeight: Yup.string()
      .matches(positiveNumberRegex, positiveNumberMsg)
      .required(" "),
    batteryDimensionsUnit: Yup.object().nullable().required(" "),
  });

  const onSubmitPS = async (values, { resetForm }) => {
    setAllocateButtonNamePS("Please wait...");
    setIsErrorAllocateItemPS(false);
    setIsSuccessAllocateItemPS(false);

    const payload = {
      cdBy: userId,
      dppId: selectedItemForPS?.dppId,
      ratedCapacity: String(values.ratedCapacity),
      ratedCapacityUnit: values.ratedCapacityUnit?.value,
      nominalVoltage: String(values.nominalVoltage),
      nominalVoltageUnit: values.nominalVoltageUnit?.value,
      powerRating: String(values.powerRating),
      powerRatingUnit: values.powerRatingUnit?.value,
      energyDensity: String(values.energyDensity),
      energyDensityUnit: values.energyDensityUnit?.value,
      batteryChemistry: values.batteryChemistry?.value,
      batteryCellFormat: values.batteryCellFormat?.value,
      // dimensions: `${values.dimensionLength}x${values.dimensionWidth}x${values.dimensionHeight}`,
      batteryDimensionsUnit: values.batteryDimensionsUnit?.value,
      size: "",
      blendRatio: "",
      wallThickness: "",
      thickness: "",
      outerDiameter: "",
      widthAcrossFlats: "",
      profileSpecifications: "",
      standardReference: "",
      height: String(values.dimensionHeight),
      width: String(values.dimensionWidth),
      length: String(values.dimensionLength),
      itemId: selectedItemForPS.itemId,
      productVariantId: selectedItemForPS.productVariantId,
    };

    try {
      let res = await createProductSpec(payload, jwtToken);

      if (res && res?.status === true) {
        setIsSuccessAllocateItemPS(true);
        resetForm();

        setTimeout(() => {
          setIsSuccessAllocateItemPS(false);
          handleClosePSModal();
          // getPassPortData(jwtToken);
        }, 1000);
      } else {
        setIsErrorAllocateItemPS(true);
        const exactError =
          res?.error || res?.msg || "Failed to create Product Specification.";
        setErrorMsg(exactError);
      }
    } catch (error) {
      setIsErrorAllocateItemPS(true);
      const backendCatchError =
        error?.response?.data?.error ||
        error?.response?.data?.msg ||
        error?.message ||
        "Something went wrong. Please try again.";
      setErrorMsg(backendCatchError);
    } finally {
      setAllocateButtonNamePS("Submit Specification");
    }
  };

  const formikPS = useFormik({
    initialValues: initialValuesPS,
    validationSchema: validationSchemaPS,
    onSubmit: onSubmitPS,
  });

  const [state, setState] = useState({
    columns: [
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "description", accessor: "description" },
      { Header: "casting Process", accessor: "castingProcess" },
      { Header: "PRODUCT CODE", accessor: "productCode" },
      { Header: "customer Part Number", accessor: "customerPartNumber" },
      { Header: "SERIAL Number", accessor: "serialNumber" },
      { Header: "version", accessor: "version" },
      { Header: "drawing Revision", accessor: "drawingRevision" },
      {
        Header: "status",
        accessor: "status",
        cannotSearch: true,
        cannotSort: true,
      },

      { Header: "industry", accessor: "industryName" },
      { Header: "brand Name", accessor: "brandName" },
      { Header: "location", accessor: "location" },

      { Header: "manufacturer", accessor: "manufacturer" },
      { Header: "quantity", accessor: "quantity" },

      { Header: "quantity Uom", accessor: "quantityUom" },
      { Header: "actualMass", accessor: "actualMass" },
      { Header: "Actual Mass Uom", accessor: "actualMassUom" },
      { Header: "variant Name", accessor: "variantName" },
      { Header: "batch Number", accessor: "batchNumber" },
      { Header: "material Grade", accessor: "materialGrade" },

      { Header: "ce Marking", accessor: "ceMarking" },

      {
        Header: "file",
        accessor: "attachments",
        cannotSearch: true,
        cannotSort: true,
      },

      {
        Header: "Created Date",
        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value ? format(new Date(value), "dd/MM/yyyy") : "";
        },
      },

      // { Header: "Created By", accessor: "cdBy" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  // const headers = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "description", key: "description" },
  //   { label: "productCode", key: "productCode" },
  //   { label: "serialNumber", key: "serialNumber" },
  //   { label: "quantity", key: "quantity" },
  //   { label: "quantity Uom", key: "quantityUom" },
  //   { label: "actualMass", key: "actualMass" },
  //   { label: "actualMassUom", key: "actualMassUom" },
  //   { label: "variantName", key: "variantName" },
  //   { label: "brandName", key: "brandName" },
  //   { label: "industryName", key: "industryName" },
  //   { label: "location", key: "location" },
  //   { label: "version", key: "version" },
  //   { label: "location", key: "location" },
  //   { label: "manufacturer", key: "manufacturer" },
  //   { label: "batchNumber", key: "batchNumber" },

  //   // { label: "productImageUrl", key: "productImageUrl" },

  //   { label: "status", key: "statusValue" },

  //   // Date Field
  //   { label: "created date", key: "createdDate" },

  //   // Action
  //   // { label: "action", key: "action" }
  // ];
  // const csvLink = {
  //   filename: "Passport.csv",
  //   headers: headers,
  //   data: rows,
  // };

  // const csvLink2 = {
  //   filename: "Passport Template.csv",
  //   headers: headers,
  //   data: [],
  // };

  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [templateAnchorEl, setTemplateAnchorEl] = useState(null);
  const [uploadTarget, setUploadTarget] = useState("parent");

  const headers = [
    { label: "Product Code", key: "productCode" },
    { label: "version", key: "version" },
    { label: "Serial Number", key: "serialNumber" },
    { label: "Batch Number", key: "batchNumber" },
    { label: "Description", key: "description" },
    { label: "Quantity", key: "quantity" },
    { label: "Quantity UOM", key: "quantityUom" },
    { label: "Actual Mass", key: "actualMass" },
    { label: "Actual Mass UOM", key: "actualMassUom" },
    { label: "Brand Name", key: "brandName" },
    { label: "GTIN Number", key: "gtinNumber" },
    { label: "Collection Model Type", key: "collectionModelType" },
    { label: "Manufacturer Company Name", key: "manufacturerCompanyName" },
    { label: "Industry Name", key: "industryName" },
    { label: "Item Code", key: "itemCode" },
    { label: "Product Variant", key: "productVariant" },
    { label: "Status", key: "status" },
    // { label: "Parent DPP Code", key: "parentDppCode" },
    // { label: "RM Item Code", key: "rmItemCode" },
    { label: "CE Marking", key: "ceMarking" },
    { label: "Customer Part Number", key: "customerPartNumber" },
    { label: "Drawing Revision", key: "drawingRevision" },
    { label: "Material Grade", key: "materialGrade" },
    { label: "Casting Process", key: "castingProcess" },
  ];

  const headersForTemp = [
    { label: "productCode", key: "productCode" },
    { label: "version", key: "version" },
    { label: "serialNumber", key: "serialNumber" },
    { label: "batchNumber", key: "batchNumber" },
    { label: "description", key: "description" },
    { label: "quantity", key: "quantity" },
    { label: "quantityUom", key: "quantityUom" },
    { label: "actualMass", key: "actualMass" },
    { label: "actualMassUom", key: "actualMassUom" },
    { label: "brandName", key: "brandName" },
    { label: "gtinNumber", key: "gtinNumber" },
    { label: "collectionModelType", key: "collectionModelType" },
    { label: "manufacturerCompanyName", key: "manufacturerCompanyName" },
    { label: "industryName", key: "industryName" },
    { label: "itemCode", key: "itemCode" },
    { label: "productVariant", key: "productVariant" },
    { label: "status", key: "status" },
    // { label: "parentDppCode", key: "parentDppCode" },
    // { label: "rmItemCode", key: "rmItemCode" },
    { label: "ceMarking", key: "ceMarking" },
    { label: "customerPartNumber", key: "customerPartNumber" },
    { label: "drawingRevision", key: "drawingRevision" },
    { label: "materialGrade", key: "materialGrade" },
    { label: "castingProcess", key: "castingProcess" },
  ];

  const csvExportData = (getPassPortReducer?.passPort.data || []).map(
    (item) => ({
      ...item,
      status:
        item.status === 0
          ? "Inactive"
          : item.status === 1
            ? "Active"
            : item.status,
    }),
  );

  const csvLink = {
    filename: "Passport List.csv",
    headers: headers,
    data: csvExportData,
  };

  const csvLink2 = {
    filename: "Passport Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const childHeaders = [
    { label: "Product Code", key: "productCode" },
    { label: "version", key: "version" },
    { label: "Serial Number", key: "serialNumber" },
    { label: "Batch Number", key: "batchNumber" },
    { label: "Description", key: "description" },
    { label: "Quantity", key: "quantity" },
    { label: "Quantity UOM", key: "quantityUom" },
    { label: "Actual Mass", key: "actualMass" },
    { label: "Actual Mass UOM", key: "actualMassUom" },
    { label: "Brand Name", key: "brandName" },
    { label: "GTIN Number", key: "gtinNumber" },
    { label: "Collection Model Type", key: "collectionModelType" },
    { label: "Manufacturer Company Name", key: "manufacturerCompanyName" },
    { label: "Industry Name", key: "industryName" },
    { label: "Item Code", key: "itemCode" },
    { label: "Product Variant", key: "productVariant" },
    { label: "Status", key: "status" },
    { label: "CE Marking", key: "ceMarking" },
    { label: "Customer Part Number", key: "customerPartNumber" },
    { label: "Drawing Revision", key: "drawingRevision" },
    { label: "Material Grade", key: "materialGrade" },
    { label: "Casting Process", key: "castingProcess" },
    { label: "Parent DPP Code", key: "parentDppCode" },
    { label: "RM Item Code", key: "rmItemCode" },
  ];

  const childHeadersForTemp = [
    { label: "productCode", key: "productCode" },
    { label: "version", key: "version" },
    { label: "serialNumber", key: "serialNumber" },
    { label: "batchNumber", key: "batchNumber" },
    { label: "description", key: "description" },
    { label: "quantity", key: "quantity" },
    { label: "quantityUom", key: "quantityUom" },
    { label: "actualMass", key: "actualMass" },
    { label: "actualMassUom", key: "actualMassUom" },
    { label: "brandName", key: "brandName" },
    { label: "gtinNumber", key: "gtinNumber" },
    { label: "collectionModelType", key: "collectionModelType" },
    { label: "manufacturerCompanyName", key: "manufacturerCompanyName" },
    { label: "industryName", key: "industryName" },
    { label: "itemCode", key: "itemCode" },
    { label: "productVariant", key: "productVariant" },
    { label: "status", key: "status" },
    { label: "ceMarking", key: "ceMarking" },
    { label: "customerPartNumber", key: "customerPartNumber" },
    { label: "drawingRevision", key: "drawingRevision" },
    { label: "materialGrade", key: "materialGrade" },
    { label: "castingProcess", key: "castingProcess" },
    { label: "parentDppCode", key: "parentDppCode" },
    { label: "rmItemCode", key: "rmItemCode" },
  ];

  const csvExportDataChild = (
    getPassPortReducer?.childPassPort?.data || []
  ).map((item) => ({
    ...item,
    status:
      item.status === 0
        ? "Inactive"
        : item.status === 1
          ? "Active"
          : item.status,
  }));

  const csvLinkChild = {
    filename: "Download Child Passport List.csv",
    headers: childHeaders,
    data: csvExportDataChild,
  };

  const csvLinkChildTemp = {
    filename: "Child Passport Upload Template.csv",
    headers: childHeadersForTemp,
    data: [],
  };

  // const uploadCsvHandler = async () => {
  //   if (!uploadCsvData) {
  //     toast.error("Please select a CSV file first!");
  //     return;
  //   }

  //   let formData = new FormData();
  //   formData.append("file", uploadCsvData);

  //   let res;

  //   if (uploadTarget === "parent") {
  //     res = await uploadCsvForPassport(formData, jwtToken);
  //   } else {
  //     res = await uploadCsvForProductPassportChild(formData, jwtToken);
  //   }

  //   if (res?.status) {
  //     toast.success(
  //       res?.data?.msg ||
  //         res?.data?.description ||
  //         `${uploadTarget === "parent" ? "Parent" : "Child"} data uploaded successfully!`,
  //     );
  //     setUploadCsvData(null);
  //     getPassPort(jwtToken);
  //   } else {
  //     toast.error(
  //       res?.data?.data?.msg ||
  //         res?.data?.msg ||
  //         res?.data?.data?.description ||
  //         res?.data?.description ||
  //         "Upload Failed",
  //     );
  //   }
  // };


  const uploadCsvHandler = async () => {
    // 1. Validation check (jo purane code me tha)
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res;

      if (uploadTarget === "parent") {
        res = await uploadCsvForPassport(formData, jwtToken);
      } else {
        res = await uploadCsvForProductPassportChild(formData, jwtToken);
      }

      if (res?.status === true || res?.data?.status === true) {
        setUploadCsvData(null);
        getPassPort(jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);

    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };




  const [loading, setLoading] = useState(true);
  const [dppIdSelected, SetdppIdSelected] = useState(true);

  useEffect(() => {
    let tempMappedActivity = [];
    let data = getPassPortReducer.passPort.data
      ? getPassPortReducer.passPort.data
      : [];
    // setPaginationObj(getPassPortReducer?.passPort?.pagination);
    setLoading(getPassPortReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.cd);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        dppCode: item.dppCode,
        serialNumber: item.serialNumber,
        description: item.description,
        location: item.location,
        batchNumber: item.batchNumber,
        manufacturer: item.manufacturer,
        actualMassUom: item.actualMassUOM,
        actualMass: item.actualMass,
        quantityUom: item.quantityUOM,
        quantity: item.quantity,
        variantName: item.variantName,
        version: item.version,

        productCode: item.productCode,

        customerPartNumber: item.customerPartNumber,
        drawingRevision: item.drawingRevision,
        castingProcess: item.castingProcess,
        materialGrade: item.materialGrade,

        industryName: item.industryName,
        brandName: item.brandName,
        // productImageUrl: item.productImageUrl,
        userId: item.userId,
        ceMarking: item.ceMarking,

        attachments: item.attachments ? (
          <MDButton
            variant="gradient"
            color="info"
            iconOnly
            disabled={!item.attachments || item.attachments.length === 0 || !item.attachments[0]?.attachmentId}
            size="small"
            style={{ padding: "4px", minWidth: "32px" }}
            onClick={() => handleOpenDocument(item)}
          >
            <Icon>
              description
            </Icon>
          </MDButton>
        ) : (
          "-"
        ),
        statusValue:
          item.status === 1
            ? "Active"
            : item.status === 0
              ? "Inactive"
              : item.status === 2
                ? "Unarchived"
                : "",
        status: (
          <button
            type="button"
            className={
              (item.status === 1 && `status-success`) ||
              (item.status === 0 && `status-error`) ||
              (item.status === 2 && `status-warning`)
            }
            style={{ width: "7rem", cursor: "pointer" }}
          >
            {(item.status === 1 && `Active`) ||
              (item.status === 0 && `Inactive`) ||
              (item.status === 2 && `Unarchived`)}
          </button>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <CreateButton
                tooltip="Add Product Specification"
                variant="gradient"
                color="dark"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenPSModal(item)}
              >
                <Icon>add</Icon>
              </CreateButton>
            )}

            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}

            <ViewButton
              tooltip="View DPP"
              variant="gradient"
              color="info"
              iconOnly
              type="button"
              onClick={() => {
                // getViewDataByDppId(dppIdSelected?.value, jwtToken);
                // setAssemblyName(assembly?.assembly);
                SetdppIdSelected(item?.dppId);
                handleOpenStationModal(item);
                getViewDataByDppId(item?.dppId, jwtToken);
              }}
            >
              <Icon> visibility_icon </Icon>
            </ViewButton>

            <ViewButton
              tooltip="View Product Specification"
              variant="gradient"
              color="secondary"
              iconOnly
              type="button"
              onClick={() => {
                setLoadingPS(true);
                setPsViewModal(true);
                SetdppIdSelected(item?.dppId);

                getProductSpecification(item?.dppId, jwtToken);
              }}
              style={{ marginLeft: "5px" }}
            >
              <Icon> list_alt </Icon>
            </ViewButton>
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getPassPortReducer]);

  const [stationTable, setStationTable] = useState({
    columns: [
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "description", accessor: "description" },
      { Header: "pRODUCT code", accessor: "productCode" },
      { Header: "sERIAL Number", accessor: "serialNumber" },
      { Header: "version", accessor: "version" },
      {
        Header: "status",
        accessor: "status",
        cannotSearch: true,
        cannotSort: true,
      },
      { Header: "location", accessor: "location" },

      { Header: "manufacturer", accessor: "manufacturer" },
      { Header: "batchNumber", accessor: "batchNumber" },

      {
        Header: "file",
        accessor: "file",
        cannotSearch: true,
        cannotSort: true,
      },

      {
        Header: "Created Date",
        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value ? format(new Date(value), "dd/MM/yyyy") : "";
        },
      },

      // { Header: "Created By", accessor: "cdBy" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const [loading2, setLoading2] = useState(true);

  const { columns: stationColumns, rows: stationRows } = stationTable;

  const [psViewModal, setPsViewModal] = useState(false);
  const [loadingPS, setLoadingPS] = useState(false);

  const [psTable, setPsTable] = useState({
    columns: [
      { Header: "Rated Capacity", accessor: "ratedCapacity" },
      { Header: "Capacity Unit", accessor: "ratedCapacityUnit" },
      { Header: "Nominal Voltage", accessor: "nominalVoltage" },
      { Header: "Voltage Unit", accessor: "nominalVoltageUnit" },
      { Header: "Power Rating", accessor: "powerRating" },
      { Header: "Power Unit", accessor: "powerRatingUnit" },
      { Header: "Energy Density", accessor: "energyDensity" },
      { Header: "Density Unit", accessor: "energyDensityUnit" },
      { Header: "Chemistry", accessor: "batteryChemistry" },
      { Header: "Cell Format", accessor: "batteryCellFormat" },
      // { Header: "Dimensions", accessor: "dimensions" },
      { Header: "Height", accessor: "height" },
      { Header: "Width", accessor: "width" },
      { Header: "Length", accessor: "length" },

      { Header: "Dimensions Unit", accessor: "batteryDimensionsUnit" },
    ],
    rows: [],
  });

  const { columns: psColumns, rows: psRows } = psTable;

  useEffect(() => {
    let tempMappedPS = [];

    let fetchedData = getProductSpecificationReducer?.productSpecification?.data
      ? getProductSpecificationReducer.productSpecification.data
      : getProductSpecificationReducer?.productSpecification || [];

    setLoadingPS(getProductSpecificationReducer?.loading || false);

    if (
      !Array.isArray(fetchedData) &&
      fetchedData &&
      Object.keys(fetchedData).length > 0
    ) {
      fetchedData = [fetchedData];
    }

    if (Array.isArray(fetchedData)) {
      fetchedData.map((item) => {
        const itemObject = {
          ratedCapacity: item.ratedCapacity || "-",
          ratedCapacityUnit: item.ratedCapacityUnit || "-",
          nominalVoltage: item.nominalVoltage || "-",
          nominalVoltageUnit: item.nominalVoltageUnit || "-",
          powerRating: item.powerRating || "-",
          powerRatingUnit: item.powerRatingUnit || "-",
          energyDensity: item.energyDensity || "-",
          energyDensityUnit: item.energyDensityUnit || "-",
          batteryChemistry: item.variantName || "-",
          batteryCellFormat: item.batteryCellFormat || "-",
          // dimensions: `${item.length || "-"} x ${item.width || "-"} x ${item.height || "-"}`,
          height: item.height || "-",
          width: item.width || "-",
          length: item.length || "-",
          batteryDimensionsUnit: item.batteryDimensionsUnit || "-",
        };
        tempMappedPS.push(itemObject);
      });
    }

    setPsTable((prevState) => ({ ...prevState, rows: tempMappedPS }));
  }, [getProductSpecificationReducer]);

  const handleClosePsViewModal = () => {
    setPsViewModal(false);
  };

  useEffect(() => {
    let tempMappedActivity = [];
    let data = getPassPortViewReducer.passPort.data
      ? getPassPortViewReducer.passPort.data
      : [];
    // setPaginationObj(getPassPortViewReducer?.passPort?.pagination);
    setLoading2(getPassPortViewReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.cd);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        dppCode: item.dppCode,
        serialNumber: item.serialNumber,
        description: item.description,
        location: item.location,
        batchNumber: item.batchNumber,
        manufacturer: item.manufacturer,
        version: item.version,
        brandName: item.brandName,
        productCode: item.productCode,
        // productImageUrl: item.productImageUrl,
        userId: item.userId,
        ceMarking: item.ceMarking,
        file: item.name ? (
          <MDButton
            variant="gradient"
            color="info"
            iconOnly
            size="small"
            style={{ padding: "4px", minWidth: "32px" }}
            onClick={() => handleOpenDocument(item)}
          >
            <Icon>
              description
            </Icon>
          </MDButton>
        ) : (
          "-"
        ),
        statusValue:
          item.status === 1
            ? "Active"
            : item.status === 0
              ? "Inactive"
              : item.status === 2
                ? "Unarchived"
                : "",
        status: (
          <button
            type="button"
            className={
              (item.status === 1 && `status-success`) ||
              (item.status === 0 && `status-error`) ||
              (item.status === 2 && `status-warning`)
            }
            style={{ width: "7rem", cursor: "pointer" }}
          >
            {(item.status === 1 && `Active`) ||
              (item.status === 0 && `Inactive`) ||
              (item.status === 2 && `Unarchived`)}
          </button>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,

        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setStationTable({ ...stationTable, rows: tempMappedActivity });
  }, [getPassPortViewReducer]);

  const [stationModal, setOpenStationModal] = useState(false);

  const handleOpenStationModal = () => {
    setOpenStationModal(true);
  };
  const handleCloseStationModal = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setOpenStationModal(false);
  };

  const [currentFile, setCurrentFile] = useState(null);

  const handleOpenDocument = (item) => {
    const attachment = item.attachments?.[0];

    if (!attachment) {
      // console.log("No attachment found");
      return;
    }

    getDppDocumentsImage(
      attachment.moduleName,
      attachment.documentType,
      attachment.attachmentName,
      jwtToken,
    );
  };

  // Watch reducer for updates
  useEffect(() => {
    const data = getDppDocumentsImageReducer.documents.data;

    if (data) {
      // Set the file for temporary use
      setCurrentFile(data);

      // Reset local state in reducer copy
      getDppDocumentsImageReducer.documents.data = null; // clears it locally
    }
  }, [getDppDocumentsImageReducer.documents.data]);

  // Optional: automatically clear currentFile after some time
  useEffect(() => {
    if (currentFile) {
      const timer = setTimeout(() => setCurrentFile(null), 1000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, [currentFile]);

  // Open file whenever currentFile updates
  useEffect(() => {
    if (!currentFile) return;

    let fileUrl;
    if (typeof currentFile === "string") fileUrl = currentFile;
    else if (currentFile.url) fileUrl = currentFile.url;
    else if (currentFile.base64) {
      const byteCharacters = atob(currentFile.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: currentFile.type || "application/octet-stream",
      });
      fileUrl = URL.createObjectURL(blob);
    } else return;

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }, [currentFile]);

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    [],
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [dppCodesOptions, setDppCodesOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getParentDppCodesReducer.dppCodes.data
      ? getParentDppCodesReducer.dppCodes.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level?.dppCode,
        value: level?.dppId,
      });
    });
    setDppCodesOptions(tempLevelOptions);
  }, [getParentDppCodesReducer]);
  const [rawMaterialOptions, setRawMaterialOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getParentRawCodesReducer.rawCodes.data
      ? getParentRawCodesReducer.rawCodes.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rmItemCode,
        value: level?.rmTraceId,
      });
    });
    setRawMaterialOptions(tempLevelOptions);
  }, [getParentRawCodesReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setParentDppIdSelected("");
    setRawDppSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setAllocateItemModal(!allocateItemModal);
    formik.setValues(initialValues);

    formik.setErrors({});
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName,
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  const [manufacturerSelected, setManufacturerSelected] = useState("");
  const handleManufacturerChange = (selectedValue) => {
    setManufacturerSelected(selectedValue);
  };

  const [itemCodeSelected, setItemCodeSelected] = useState("");
  const handleItemCodeChange = (selectedValue) => {
    setItemCodeSelected(selectedValue);
  };

  const [productVariantSelected, setProductVariantSelected] = useState("");
  const handleProductVariantChange = (selectedValue) => {
    setProductVariantSelected(selectedValue);
  };

  const [manufacturerOptions, setManufacturerOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = getManufacturerDetailsReducer.manufacturerDetails.data
      ? getManufacturerDetailsReducer.manufacturerDetails.data
      : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.companyName,
        value: zone.manufacturerId,
        quantity: zone.quantity,
        actualMass: zone.actualMass,

        quantityUOM: zone.quantityUOM,
        actualMassUOM: zone.actualMassUOM,
      });
    });
    setManufacturerOptions(tempZonesByWarehouse);
  }, [getManufacturerDetailsReducer]);

  const [IndustryOptions, setIndustryOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = getIndustryTypeReducer.dpp.data
      ? getIndustryTypeReducer.dpp.data
      : [];
    console.log("dataa", data);
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.name,
        value: zone.industryId,
        // quantity: zone.quantity,
        // actualMass: zone.actualMass,

        // quantityUOM: zone.quantityUOM,
        // actualMassUOM: zone.actualMassUOM,
      });
    });
    setIndustryOptions(tempZonesByWarehouse);
  }, [getIndustryTypeReducer]);

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [productVariantOptions, setProductVariantOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = getProductVariantReducer.productVariant.data
      ? getProductVariantReducer.productVariant.data
      : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.variantName,
        value: zone.productVariantId,
      });
    });
    setProductVariantOptions(tempZonesByWarehouse);
  }, [getProductVariantReducer]);

  const initialValues = {
    type: "parent",
    productCode: "",
    serialNumber: "",
    version: "",
    batchNumber: "",
    Description: "",
    // dppCode:"",
    status: "",
    Location: "",
    productImageUrl: "",
    Manufacture: "",
    file: "",
    quantity: "",
    actualMass: "",
    actualMassUOM: "",
    quantityUOM: "",
    brandName: "",
    brandLogoUrl: "",
    GTINNumber: "",
    customerPartNumber: "",
    drawingRevision: "",
    materialGrade: "",
    castingProcess: "",
    ceMarking: 0,
    ceCertificate: null,
  };

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getPassPort(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getPassPort(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const validationSchemaForAssembly = Yup.object({
    QuantityUpdate: Yup.string().required(" "),
    ActualMass: Yup.string().required("Enter Actual Mass"),
    GTINNumber: Yup.string().required(" "),
    actualMassUOM: Yup.mixed().required(" "),
    CollectionModelType: Yup.string()
      .required(" ")
      .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
    brandName: Yup.string()
      .required(" ")
      .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
    quantityUOM: Yup.mixed().required(" "),

    GTINNumber: Yup.string()
      .required(" ")
      .matches(
        /^[0-9]{8}$|^[0-9]{12}$|^[0-9]{13}$|^[0-9]{14}$/,
        "GTIN must be 8, 12, 13, or 14 digits",
      ),

    // customerPartNumber: Yup.string().required(" "),
    // drawingRevision: Yup.string().required(" "),
    // materialGrade: Yup.string().required(" "),
    // castingProcess: Yup.string().required(" "),

    customerPartNumber: Yup.string()
      .trim()
      .required(" ")
      .matches(
        /^[A-Za-z0-9-]+$/,
        "Only letters, numbers, and hyphen (-) are allowed",
      ),

    drawingRevision: Yup.string()
      .trim()
      .required(" ")
      .matches(/^[A-Za-z0-9 .-]+$/, "Only letters and spaces are allowed"),

    materialGrade: Yup.string()
      .trim()
      .required(" ")
      .matches(
        /^[A-Za-z0-9 -]+$/, 
        "Only letters, numbers, and hyphen (-) are allowed",
      ),

    castingProcess: Yup.string()
      .trim()
      .required(" ")
      .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed"),

    version: Yup.string().trim().required(" "),
  });

  // const validationSchema = Yup.object({
  //   productCode: Yup.string()
  //     .matches(
  //       /^[A-Za-z0-9-]+$/,
  //       "Only letters, numbers, and hyphen (-) are allowed"
  //     )
  //     .required(" "),
  //   serialNumber: Yup.string()
  //     .matches(
  //       /^[A-Za-z0-9]+$/,
  //       "Only letters and numbers are allowed"
  //     )
  //     .required(" "),
  //   manufacturerName: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   Industry: Yup.object()
  //     .nullable()
  //     .required(" "),
  //   manufacturerItem: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   manufacturerProductVariant: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   status: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   manufacturerProductVariant: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   status: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   status: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   batchNumber: Yup.string()
  //     .matches(
  //       /^[A-Za-z0-9]+$/,
  //       "Only letters and numbers are allowed"
  //     )
  //     .required(" "),
  //   // Description: Yup.string().required(" "),

  //   Description: Yup.string()
  //     .required(" ")
  //     .matches(
  //       /^[a-zA-Z0-9\s-]+$/,
  //       "Only alphanumeric characters, hyphens, and spaces are allowed"
  //     ),
  //   version: Yup.string().required(" "),

  //   quantityUOM: Yup.mixed().required(" "),

  //   quantity: Yup.string().required(" "), actualMass: Yup.string()
  //     .required(" ")
  //     .matches(/^\d+$/, "Only numbers are allowed"),
  //   actualMassUOM: Yup.mixed().required(" "),
  //   CollectionModelType: Yup.string()
  //     .required(" ")
  //     .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  //   brandName: Yup.string()
  //     .required(" ")
  //     .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  //   quantityUOM: Yup.mixed().required(" "),
  //   GTINNumber: Yup.string()
  //     .required(" ")
  //     .matches(
  //       /^[0-9]{8}$|^[0-9]{12}$|^[0-9]{13}$|^[0-9]{14}$/,
  //       "GTIN must be 8, 12, 13, or 14 digits"
  //     ),
  //   version: Yup.string()
  //     .required(" ")
  //     .matches(
  //       /^v?\d+(\.\d+)?$/i,
  //       "Only Allowed: v1.0, v1, 1"
  //     ),

  //   customerPartNumber: Yup.string()
  //     .trim()
  //     .required(" ")
  //     .matches(
  //       /^[A-Za-z0-9-]+$/,
  //       "Only letters, numbers, and hyphen (-) are allowed"
  //     ),

  //   drawingRevision: Yup.string()
  //     .trim()
  //     .required(" ")
  //     .matches(
  //       /^[A-Za-z\s]+$/,
  //       "Only letters and spaces are allowed"
  //     ),

  //   materialGrade: Yup.string()
  //     .trim()
  //     .required(" ")
  //     .matches(
  //       /^[A-Za-z0-9-]+$/,
  //       "Only letters, numbers, and hyphen (-) are allowed"
  //     ),

  //   castingProcess: Yup.string()
  //     .trim()
  //     .required(" ")
  //     .matches(
  //       /^[A-Za-z\s]+$/,
  //       "Only letters and spaces are allowed"
  //     ),

  // });

  const getValidationSchema = (industryId) => {
    const id = Number(industryId);

    return Yup.object({
      productCode: Yup.mixed()
        .required(" "),

      serialNumber: Yup.string()
        .matches(/^[A-Za-z0-9]+$/, "Only letters and numbers are allowed")
        .required(" "),

      manufacturerName: Yup.object().nullable().required(" "),
      Industry: Yup.object().nullable().required(" "),
      manufacturerItem: Yup.object().nullable().required(" "),
      manufacturerProductVariant: Yup.object().nullable().required(" "),
      status: Yup.object().nullable().required(" "),

      batchNumber: Yup.string()
        .matches(/^[A-Za-z0-9]+$/, "Only letters and numbers are allowed")
        .required(" "),

      Description: Yup.string()
        .matches(
          /^[a-zA-Z0-9\s-]+$/,
          "Only alphanumeric characters, hyphens, and spaces are allowed",
        )
        .required(" "),

      version: Yup.string()
        .required(" "),

      quantity: Yup.string().required(" "),
      quantityUOM: Yup.mixed().required(" "),

      actualMass: Yup.string()
        .matches(/^\d+$/, "Only numbers are allowed")
        .required(" "),

      actualMassUOM: Yup.mixed().required(" "),

      CollectionModelType: Yup.string()
        .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
        .required(" "),

      brandName: Yup.string()
        .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
        .required(" "),

      GTINNumber: Yup.string()
        .matches(
          /^[0-9]{8}$|^[0-9]{12}$|^[0-9]{13}$|^[0-9]{14}$/,
          "GTIN must be 8, 12, 13, or 14 digits",
        )
        .required(" "),

      ceMarking: Yup.string().required(" "),

      customerPartNumber:
        id === 1
          ? Yup.string()
            .trim()
            .matches(
              /^[A-Za-z0-9-]+$/,
              "Only letters, numbers, and hyphen (-) are allowed",
            )
            .required(" ")
          : Yup.string()
            .trim()
            .matches(
              /^[A-Za-z0-9-]+$/,
              "Only letters, numbers, and hyphen (-) are allowed",
            ),

      drawingRevision:
        id === 1
          ? Yup.string()
            .trim()
            .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed")
            .required(" ")
          : Yup.string()
            .trim()
            .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed"),

      materialGrade:
        id === 1
          ? Yup.string()
            .trim()
            .matches(
              /^[A-Za-z0-9-]+$/,
              "Only letters, numbers, and hyphen (-) are allowed",
            )
            .required(" ")
          : Yup.string()
            .trim()
            .matches(
              /^[A-Za-z0-9-]+$/,
              "Only letters, numbers, and hyphen (-) are allowed",
            ),

      castingProcess:
        id === 1
          ? Yup.string()
            .trim()
            .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed")
            .required(" ")
          : Yup.string()
            .trim()
            .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed"),
    });
  };

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const [allocateButtonNamePS, setAllocateButtonNamePS] = useState(
    "Submit Specifications",
  );

  // const onSubmit = async (values, { resetForm }) => {
  //   setAllocateButtonName("Please wait...");

  //   const formData = new FormData();

  //   formData.append("userId", userId);
  //   formData.append(
  //     "status",
  //     warehouseIdSelected?.value ? warehouseIdSelected?.value : "",
  //   );

  //   if (values.type === "child") {
  //     formData.append(
  //       "parentId",
  //       ParentDppIdSelected?.value ? ParentDppIdSelected?.value : "",
  //     );
  //     formData.append(
  //       "rmTraceId",
  //       RawDppSelected?.value ? RawDppSelected?.value : "",
  //     );
  //   }

  //   formData.append("productCode", values.productCode);
  //   formData.append("serialNumber", values.serialNumber);
  //   formData.append("location", values.Location);
  //   formData.append("batchNumber", values.batchNumber);
  //   formData.append("description", values.Description);
  //   formData.append("dppCode", values.dppCode);
  //   formData.append("brandLogoUrl", values.brandLogoUrl);
  //   formData.append("brandName", values.brandName);
  //   formData.append("gtinNumber", values.GTINNumber);
  //   formData.append("collectionModelType", values.CollectionModelType);
  //   formData.append("industryId", values.Industry?.value);
  //   formData.append("manufacturer", values.manufacturerName?.label);
  //   formData.append("manufacturerId", values.manufacturerName?.value);
  //   formData.append(
  //     "actualMassUom",
  //     String(values.actualMassUOM?.value || values.actualMassUOM),
  //   );
  //   formData.append(
  //     "quantityUom",
  //     values.quantityUOM?.value || values.quantityUOM,
  //   );
  //   formData.append("quantity", String(values.quantity));
  //   formData.append("actualMass", String(values.actualMass));

  //   formData.append("customerPartNumber", values.customerPartNumber);

  //   formData.append("drawingRevision", values.drawingRevision);

  //   formData.append("materialGrade", values.materialGrade);

  //   formData.append("castingProcess", values.castingProcess);

  //   formData.append(
  //     "productVariantId",
  //     values.manufacturerProductVariant?.value,
  //   );
  //   formData.append("itemId", values.manufacturerItem?.value);
  //   formData.append("version", values.version);
  //   formData.append("documentType", "productImage");
  //   formData.append("moduleName", "productPassport");

  //   const documentDetails = [];

  //   if (values.brandLogoImage) {
  //     formData.append("brandLogoImage", values.brandLogoImage);

  //     documentDetails.push({
  //       fileName: values.brandLogoImage.name,
  //       fileType: "brandLogoImage",
  //     });
  //   }

  //   if (values.file) {
  //     formData.append("productImage", values.file);

  //     documentDetails.push({
  //       fileName: values.file.name,
  //       fileType: "productImage",
  //     });
  //   }

  //   // if (values.type === "parent") {
  //     // if (values.ceMarking) {
  //       formData.append("ceMarking", values.ceMarking.value || 0);
  //     // }

  //     if (values.ceMarking?.value === 1 && values.ceCertificate) {
  //       formData.append("ceCertificate", values.ceCertificate);

  //       documentDetails.push({
  //         fileName: values.ceCertificate.name,
  //         fileType: "ceCertificate",
  //       });
  //     }
  //   // }

  //   formData.append("documentDetails", JSON.stringify(documentDetails));

  //   const res = await createPassPort(formData, jwtToken);

  //   if (res.status) {
  //     setIsSuccessAllocateItem(true);
  //     getPassPort(dppIdSelectedForGlobalFilter?.value, jwtToken);
  //     formik.setErrors({});

  //     resetForm();

  //     setTimeout(() => {
  //       setAllocateButtonName("Create");
  //       handleCloseAllocateItemModal();
  //     }, 2250);
  //   } else {
  //     setErrorMsg(res?.data?.data?.msg);
  //     setAllocateButtonName("Create");
  //     setIsErrorAllocateItem(true);
  //   }
  // };


  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");

    const formData = new FormData();

    formData.append("userId", userId);
    formData.append(
      "status",
      warehouseIdSelected?.value ? warehouseIdSelected?.value : "",
    );

    if (values.type === "child") {
      formData.append(
        "parentId",
        ParentDppIdSelected?.value ? ParentDppIdSelected?.value : "",
      );
      formData.append(
        "rmTraceId",
        RawDppSelected?.value ? RawDppSelected?.value : "",
      );
    }

    formData.append("productCode", values.productCode);
    formData.append("serialNumber", values.serialNumber);
    formData.append("location", values.Location);
    formData.append("batchNumber", values.batchNumber);
    formData.append("description", values.Description);
    formData.append("dppCode", values.dppCode);
    formData.append("brandLogoUrl", values.brandLogoUrl);
    formData.append("brandName", values.brandName);
    formData.append("gtinNumber", values.GTINNumber);
    formData.append("collectionModelType", values.CollectionModelType);
    formData.append("industryId", values.Industry?.value);
    formData.append("manufacturer", values.manufacturerName?.label);
    formData.append("manufacturerId", values.manufacturerName?.value);
    formData.append(
      "actualMassUom",
      String(values.actualMassUOM?.value || values.actualMassUOM),
    );
    formData.append(
      "quantityUom",
      values.quantityUOM?.value || values.quantityUOM,
    );
    formData.append("quantity", String(values.quantity));
    formData.append("actualMass", String(values.actualMass));

    formData.append("customerPartNumber", values.customerPartNumber);
    formData.append("drawingRevision", values.drawingRevision);
    formData.append("materialGrade", values.materialGrade);
    formData.append("castingProcess", values.castingProcess);

    formData.append(
      "productVariantId",
      values.manufacturerProductVariant?.value,
    );
    formData.append("itemId", values.manufacturerItem?.value);
    formData.append("version", values.version);
    formData.append("documentType", "productImage");
    formData.append("moduleName", "productPassport");

    const documentDetails = [];

    if (values.brandLogoImage) {
      formData.append("brandLogoImage", values.brandLogoImage);

      documentDetails.push({
        fileName: values.brandLogoImage.name,
        fileType: "brandLogoImage",
      });
    }

    if (values.file) {
      formData.append("productImage", values.file);

      documentDetails.push({
        fileName: values.file.name,
        fileType: "productImage",
      });
    }

    const ceMarkingValue = (values.ceMarking === 1 || values.ceMarking === "1") ? 1 : 0;
    formData.append("ceMarking", ceMarkingValue);

    if (ceMarkingValue === 1 && values.ceCertificate) {
      formData.append("ceCertificate", values.ceCertificate);

      documentDetails.push({
        fileName: values.ceCertificate.name,
        fileType: "ceCertificate",
      });
    }

    formData.append("documentDetails", JSON.stringify(documentDetails));

    const res = await createPassPort(formData, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getPassPort(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});

      resetForm();

      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    } else {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let dppId = singleDataForDelete.dppId;
    // let userId = singleDataForDelete.userId;

    let res = await deletePassport(dppId, userId);

    if (res.status) {
      getPassPort(dppIdSelectedForGlobalFilter?.value, jwtToken);
      getViewDataByDppId(dppIdSelected, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validationSchema,
    validationSchema: () => getValidationSchema(dppIdSelected?.industryId),
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getMappedActivity(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");
  const [IndustrySelectedForEdit, setIndustrySelectedForEdit] = useState("");
  const [manufacturerSelectedForEdit, setManufacturerSelectedForEdit] =
    useState("");
  const [manufacturerItemSelectedForEdit, setManufacturerItemSelectedForEdit] =
    useState("");

  const [ProductSelectedForEdit, setProductSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState("");
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const [openTypeConfirmModal, setOpenTypeConfirmModal] = useState(false);
  const [pendingTypeChange, setPendingTypeChange] = useState("");

  // console.log("IndustrySelectedForEdit", IndustrySelectedForEdit);

  const activeDataOptions = [
    { label: "Active", value: "1" },
    { label: "InActive", value: "0" },
    { label: "Unarchived", value: "2" },
  ];

  // const handleOpenUpdateModal = (singleData) => {
  //   // getWarehousesByMovement(singleData.acnId, jwtToken);
  //   // // getZonesByWarehouse(singleData.zoneId, jwtToken);
  //   // getLevel1ByLevel(singleData.warehouseId, 0, jwtToken);
  //   // getLevel2ByLevel(singleData.warehouseId, singleData.zoneId, jwtToken);
  //   // getLevel3ByLevel(singleData.warehouseId, singleData.sectionId, jwtToken);
  //   // getLevel4ByLevel(singleData.warehouseId, singleData.rackId, jwtToken);
  //   // setWarehouseTypesSelectedForEdit({
  //   //   label: singleData.warehouseCode,
  //   //   value: singleData.warehouseId,
  //   // });
  //   // setItemCodeSelectedForEdit({
  //   //   label: singleData.itemCode,
  //   //   value: singleData.itemId,
  //   // });
  //   // setAcnTypeSelectedForEdit({
  //   //   label: singleData.acnCode,
  //   //   value: singleData.acnId,
  //   // });
  //   // setZoneSelectedForEdit({
  //   //   label: singleData.zone,
  //   //   value: singleData.zoneId,
  //   // });
  //   // setSectionSelectedForEdit({
  //   //   label: singleData.section,
  //   //   value: singleData.sectionId,
  //   // });
  //   // setRackSelectedForEdit({
  //   //   label: singleData.rack,
  //   //   value: singleData.rackId,
  //   // });
  //   setLocationSelectedForEdit({
  //     label:
  //       (singleData.status === 1 && "Active") ||
  //       (singleData.status === 0 && "Inactive") ||
  //       (singleData.status === 2 && "Unarchived"),
  //     value: singleData.status,
  //   });
  //   setManufacturerSelectedForEdit({
  //     label: singleData.manufacturer,
  //     value: singleData.manufacturerId,
  //   });
  //   setManufacturerItemSelectedForEdit({
  //     label: singleData.itemCode,
  //     value: singleData.itemId,
  //   });
  //   setProductSelectedForEdit({
  //     label: singleData.variantName,
  //     value: singleData.productVariantId,
  //   });
  //   setIndustrySelectedForEdit({
  //     label: singleData.industryName,
  //     value: singleData.industryId,
  //   });

  //   setSingleFgDataForUpdate(singleData);
  //   setOpenUpdateModal(true);

  //   // getWarehousesByMovement(
  //   //   acnTypeSelectedForEdit?.value,

  //   //   jwtToken
  //   // );
  // };

  const handleOpenUpdateModal = (singleData) => {
    // Status ka label properly set karne ke liye
    let statusLabel = "";
    if (singleData.status === 1) statusLabel = "Active";
    else if (singleData.status === 0) statusLabel = "Inactive";
    else if (singleData.status === 2) statusLabel = "Unarchived";

    setLocationSelectedForEdit({
      label: statusLabel,
      value: singleData.status,
    });

    setManufacturerSelectedForEdit({
      label: singleData.manufacturer,
      value: singleData.manufacturerId,
    });

    setManufacturerItemSelectedForEdit({
      label: singleData.itemCode,
      value: singleData.itemId,
    });

    setProductSelectedForEdit({
      label: singleData.variantName,
      value: singleData.productVariantId,
    });

    setdppIdForUpdateSelected({
      label: singleData.dppCode,
      value: singleData.dppId,
      industryId: singleData.industryId,
    });

    setIndustrySelectedForEdit({
      label: singleData.industryName,
      value: singleData.industryId,
    });

    // Modal data state me set kar diya
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);
  };

  const handleConfirmTypeChange = () => {
    formik.resetForm({
      values: {
        ...formik.initialValues,
        type: pendingTypeChange,
      },
    });
    setOpenTypeConfirmModal(false);
  };

  const handleCancelTypeChange = () => {
    setOpenTypeConfirmModal(false);
    setPendingTypeChange("");
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };
  const handleChangeLocationForEditForIndustry = (selectedOption) => {
    setIndustrySelectedForEdit(selectedOption);
  };
  const handleChangeManuForEdit = (selectedOption) => {
    setManufacturerSelectedForEdit(selectedOption);
  };
  const handleChangeManuItemForEdit = (selectedOption) => {
    setManufacturerItemSelectedForEdit(selectedOption);
  };
  const handleChangeManuProductForEdit = (selectedOption) => {
    setProductSelectedForEdit(selectedOption);
  };

  // console.log("singleFgDataForUpdate", singleFgDataForUpdate)
  const initialValueForUpdate = {
    productCode: singleFgDataForUpdate.productCode,
    serialNumber: singleFgDataForUpdate.serialNumber,
    version: singleFgDataForUpdate.version,
    Location: singleFgDataForUpdate.location,
    manufacturer: singleFgDataForUpdate.manufacturer,
    industry: singleFgDataForUpdate.industry,
    ActualMass: singleFgDataForUpdate.actualMass,
    actualMassUOM: singleFgDataForUpdate.actualMassUOM,
    quantityUOM: singleFgDataForUpdate.quantityUOM,
    QuantityUpdate: singleFgDataForUpdate.quantity,
    productImageUrl: singleFgDataForUpdate.productImageUrl,
    GTINNumber: singleFgDataForUpdate.gtinNumber,
    CollectionModelType: singleFgDataForUpdate.collectionModelType,
    brandName: singleFgDataForUpdate.brandName,
    brandUrl: singleFgDataForUpdate.brandLogoUrl,
    batchNumber: singleFgDataForUpdate.batchNumber,
    Description: singleFgDataForUpdate.description,
    // ceMarking: singleFgDataForUpdate.ceMarking,
    ceMarking:
      singleFgDataForUpdate.ceMarking === "Yes" ? 1 :
        singleFgDataForUpdate.ceMarking === "No" ? 0 :
          singleFgDataForUpdate.ceMarking,

    customerPartNumber: singleFgDataForUpdate.customerPartNumber || "",
    drawingRevision: singleFgDataForUpdate.drawingRevision || "",
    materialGrade: singleFgDataForUpdate.materialGrade || "",
    castingProcess: singleFgDataForUpdate.castingProcess || "",
    // version: singleFgDataForUpdate?.version || "",
  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }

    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const formData = new FormData();
    formData.append("udBy", userId);
    formData.append("dppId", singleFgDataForUpdate.dppId);
    formData.append("dppCode", singleFgDataForUpdate.dppCode);
    formData.append("itemId", manufacturerItemSelectedForEdit?.value);
    formData.append("status", locationSelectedForEdit?.value);
    formData.append("productCode", values.productCode);
    formData.append("collectionModelType", values.CollectionModelType);
    formData.append("serialNumber", values.serialNumber);
    formData.append("version", values.version);
    formData.append("productImageUrl", values.productImageUrl);
    // formData.append("actualMassUom", values.actualMassUOM);
    // formData.append("quantityUom", values.quantityUOM); 
    formData.append(
      "actualMassUom",
      values.actualMassUOM?.value || values.actualMassUOM || ""
    );

    formData.append(
      "quantityUom",
      values.quantityUOM?.value || values.quantityUOM || ""
    );
    // formData.append("location", values.Location);
    formData.append("batchNumber", values.batchNumber);

    formData.append("brandLogoUrl", values.brandUrl);
    formData.append("brandName", values.brandName);
    formData.append("industryId", IndustrySelectedForEdit?.value);
    formData.append("actualMass", values.ActualMass);
    formData.append("quantity", values.QuantityUpdate);
    formData.append("productVariantId", ProductSelectedForEdit?.value);

    formData.append("gtinNumber", values.GTINNumber);

    formData.append("description", values.Description);
    formData.append("manufacturerId", manufacturerSelectedForEdit?.value);

    formData.append("documentType", "productImage");
    formData.append("moduleName", "productPassport");

    formData.append("customerPartNumber", values.customerPartNumber);
    formData.append("drawingRevision", values.drawingRevision);
    formData.append("materialGrade", values.materialGrade);
    formData.append("castingProcess", values.castingProcess);
    // formData.append("version", values.version);

    const documentDetails = [];

    if (values.file instanceof File) {
      formData.append("productImage", values.file);

      documentDetails.push({
        fileName: values.file.name,
        fileType: "productImage",
      });
    }

    if (values.brandLogoImage instanceof File) {
      formData.append("brandLogoImage", values.brandLogoImage);

      documentDetails.push({
        fileName: values.brandLogoImage.name,
        fileType: "brandLogoImage",
      });
    }

    // if (values.ceMarking) {
    //   formData.append("ceMarking", values.ceMarking.value);
    // } else {
    //   formData.append("ceMarking", 0);
    // }
    const ceMarkingValue = (values.ceMarking === 1 || values.ceMarking === "1") ? 1 : 0;
    formData.append("ceMarking", ceMarkingValue);


    if (values.ceMarking?.value === 1 && values.ceCertificate) {
      formData.append("ceCertificate", values.ceCertificate);
    }

    formData.append("documentDetails", JSON.stringify(documentDetails));
    const res = await editPassport(formData, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getPassPort(dppIdSelectedForGlobalFilter?.value, jwtToken);

      getViewDataByDppId(dppIdSelected, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForAssembly,
    // validationSchema: () => getValidationSchema(IndustrySelectedForEdit?.value),

    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getMappedActivity(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});



  const subModuleId = "14087f18-c281-4ed7-9f1a-c1b627b50f8e";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  // let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getPassPort(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  useEffect(() => {
    // Check if productCode, version, and batchNumber have values, then update dppCode
    if (
      formik.values.productCode &&
      formik.values.version &&
      formik.values.batchNumber
    ) {
      formik.setFieldValue(
        "dppCode",
        `${formik.values.productCode}-${formik.values.batchNumber}-${formik.values.version}`,
      );
    }
  }, [
    formik.values.productCode,
    formik.values.version,
    formik.values.batchNumber,
  ]);

  const [isUploading, setIsUploading] = useState(false);

  const uploadDocumentHandler = async () => {
    if (!formik.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 Match backend / Postman keys
    data.append("File", formik.values.file); // file
    data.append("module_name", "passport"); // text (or product_image if backend expects that)

    try {
      const res = await uploadForUrl(data, jwtToken);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill image URL
        formik.setFieldValue("productImageUrl", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };
  const uploadDocumentHandlerForUpdate = async () => {
    if (!formikForUpdate.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 Must match Postman keys

    // 🔑 MUST match Postman keys
    data.append("File", formikForUpdate.values.file); // file
    data.append("module_name", "passport"); // text (or product_image if backend expects that)

    try {
      const res = await uploadForUrl(data);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill Proof Document URL
        formikForUpdate.setFieldValue("productImageUrl", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  useEffect(() => {
    getParentRawCodes(ParentDppIdSelected?.value, jwtToken);
  }, [ParentDppIdSelected]);
  const hideProductImageUrl = true;
  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox
                color="text"
                px={2}
                ml={-2}
                mb={4}
                display="flex"
                alignItems="center"
              >
                {allocateAccess && (
                  <MDBox display="flex" alignItems="center">
                    <Tooltip>
                      <CreateButton
                        tooltip="Add Passport"
                        color="info"
                        variant="contained"
                        type="button"
                        iconOnly
                        onClick={(event) => {
                          handleAllocateItemModal();
                          getWarehouses(jwtToken);
                          getItemMaster(jwtToken);
                          getAcn(jwtToken);
                          getParentDppCode(jwtToken);
                          getRelationLocation(jwtToken);
                        }}
                        style={{ borderRadius: "5px" }}
                        size="small"
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </Tooltip>
                    <CSVLink
                      {...csvLink}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      <DownloadDataButton
                        tooltip="Download Passport List"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                        onClick={(e) => setDownloadAnchorEl(e.currentTarget)}
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>

                    <UploadButton
                      tooltip="Upload CSV"
                      style={{ marginLeft: "1rem", marginTop: "2px" }}
                      type="button"
                      variant={uploadCsvFilter ? "contained" : "outlined"}
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>

                    <DownloadButton
                      tooltip="Download Template"
                      style={{ marginLeft: "1rem", marginTop: "2px" }}
                      type="button"
                      variant="outlined"
                      color="error"
                      iconOnly
                      onClick={(e) => setTemplateAnchorEl(e.currentTarget)}
                    >
                      <Icon>description</Icon>
                    </DownloadButton>

                    <Menu
                      anchorEl={templateAnchorEl}
                      open={Boolean(templateAnchorEl)}
                      onClose={() => setTemplateAnchorEl(null)}
                    >
                      <MenuItem onClick={() => setTemplateAnchorEl(null)}>
                        <CSVLink
                          {...csvLink2}
                          style={{ color: "inherit", textDecoration: "none" }}
                        >
                          Parent Template
                        </CSVLink>
                      </MenuItem>
                      <MenuItem onClick={() => setTemplateAnchorEl(null)}>
                        <CSVLink
                          {...csvLinkChildTemp}
                          style={{ color: "inherit", textDecoration: "none" }}
                        >
                          Child Template
                        </CSVLink>
                      </MenuItem>
                    </Menu>

                    {uploadCsvFilter && (
                      <MDBox
                        display="flex"
                        alignItems="center"
                        ml={2}
                        p={0.5}
                        px={2}
                      >
                        <select
                          value={uploadTarget}
                          onChange={(e) => setUploadTarget(e.target.value)}
                          style={{
                            padding: "6px 12px",
                            borderRadius: "8px",
                            marginRight: "10px",
                            borderColor: "#ccc",
                            height: "39px",
                            cursor: "pointer",
                            outline: "none",
                          }}
                        >
                          <option value="parent">Parent</option>
                          <option value="child">Child</option>
                        </select>

                        <input
                          className="choose_file"
                          type="file"
                          accept=".csv"
                          onChange={(e) => setUploadCsvData(e.target.files[0])}
                          style={{ width: "200px" }}
                        />

                        <MDButton
                          disabled={
                            !uploadCsvData?.name ||
                            uploadCsvData?.type !== "text/csv"
                          }
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "1rem" }}
                          type="button"
                          onClick={uploadCsvHandler}
                        >
                          UPLOAD
                        </MDButton>

                        <IconButton
                          size="small"
                          onClick={() => {
                            setUploadCsvData(null);
                          }}
                          style={{ marginLeft: "10px", color: "gray" }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </MDBox>
                    )}
                  </MDBox>
                )}
              </MDBox>
            </MDBox>

            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>

            <Modal
              open={stationModal}
              onClose={handleCloseStationModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForStationModal}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Dpp Code
                  </MDTypography>

                  <MDBox display="flex" marginLeft="auto">
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            display: "flex",
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "auto",
                            marginBottom: "5px",
                            marginRight: "10px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseStationModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginBottom: "1rem" }} />
                <MDBox>
                  {!loading2 ? (
                    <DataTable
                      table={{ columns: stationColumns, rows: stationRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                      hideColumns={["createdDate"]}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        marginBottom: "100px",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )}
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            <Modal
              open={openTypeConfirmModal}
              onClose={handleCancelTypeChange}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography variant="h6" fontWeight="medium">
                  Change Type?
                </MDTypography>
                <MDTypography variant="body2" color="text" mt={1}>
                  Changing the type will clear all entered data. Continue ?
                </MDTypography>
                <MDBox mt={3} display="flex" justifyContent="flex-end">
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCancelTypeChange}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={handleConfirmTypeChange}
                  >
                    Continue
                  </MDButton>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Product Code
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="productCode"
                              disabled
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.productCode}
                              error={
                                formikForUpdate.touched.productCode &&
                                formikForUpdate.errors.productCode &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.productCode &&
                              formikForUpdate.errors.productCode && (
                                <TextError
                                  msg={formikForUpdate.errors.productCode}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Customer Part Number
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="customerPartNumber"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.customerPartNumber}
                              error={
                                formikForUpdate.touched.customerPartNumber &&
                                formikForUpdate.errors.customerPartNumber &&
                                true
                              }
                              inputProps={{
                                style: { height: "10px" },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.customerPartNumber &&
                              formikForUpdate.errors.customerPartNumber && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.customerPartNumber
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Casting Process */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Casting Process
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="castingProcess"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.castingProcess}
                              error={
                                formikForUpdate.touched.castingProcess &&
                                formikForUpdate.errors.castingProcess &&
                                true
                              }
                              inputProps={{
                                style: { height: "10px" },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.castingProcess &&
                              formikForUpdate.errors.castingProcess && (
                                <TextError
                                  msg={formikForUpdate.errors.castingProcess}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">version</MDTypography>
                            <MDInput
                              type="text"
                              name="version"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.version}
                              error={
                                formikForUpdate.touched.version &&
                                formikForUpdate.errors.version &&
                                true
                              }
                              inputProps={{
                                style: { height: "10px" },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.version &&
                              formikForUpdate.errors.version && (
                                <TextError
                                  msg={formikForUpdate.errors.version}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Drawing Revision */}
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Drawing Revision
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="drawingRevision"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.drawingRevision}
                              error={
                                formikForUpdate.touched.drawingRevision &&
                                formikForUpdate.errors.drawingRevision &&
                                true
                              }
                              inputProps={{
                                style: { height: "10px" },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.drawingRevision &&
                              formikForUpdate.errors.drawingRevision && (
                                <TextError
                                  msg={formikForUpdate.errors.drawingRevision}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Serial Number
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="serialNumber"
                              fullWidth
                              disabled
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.serialNumber}
                              error={
                                formikForUpdate.touched.serialNumber &&
                                formikForUpdate.errors.serialNumber &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.serialNumber &&
                              formikForUpdate.errors.serialNumber && (
                                <TextError
                                  msg={formikForUpdate.errors.serialNumber}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Batch Number
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="batchNumber"
                              disabled
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.batchNumber}
                              error={
                                formikForUpdate.touched.batchNumber &&
                                formikForUpdate.errors.batchNumber &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.batchNumber &&
                              formikForUpdate.errors.batchNumber && (
                                <TextError
                                  msg={formikForUpdate.errors.batchNumber}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Material Grade */}
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Material Grade
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="materialGrade"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.materialGrade}
                              error={
                                formikForUpdate.touched.materialGrade &&
                                formikForUpdate.errors.materialGrade &&
                                true
                              }
                              inputProps={{
                                style: { height: "10px" },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.materialGrade &&
                              formikForUpdate.errors.materialGrade && (
                                <TextError
                                  msg={formikForUpdate.errors.materialGrade}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Description{" "}
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="Description"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Description}
                              error={
                                formikForUpdate.touched.Description &&
                                formikForUpdate.errors.Description &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Description &&
                              formikForUpdate.errors.Description && (
                                <TextError
                                  msg={formikForUpdate.errors.Description}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Manufacturer
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              // maxMenuHeight={70}
                              placeholder="Select..."
                              name="manufacturer"
                              options={manufacturerOptions}
                              value={manufacturerSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeManuForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "manufacturer",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForUpdate.touched.manufacturer &&
                              formikForUpdate.errors.manufacturer && (
                                <TextError
                                  msg={formikForUpdate.errors.manufacturer}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6" ml={1}>
                              Item
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Choose one..."
                              name="manufacturerItem"
                              options={itemCodeOptions}
                              value={manufacturerItemSelectedForEdit}
                              onChange={(selectedOption) => {
                                // formikForUpdate.setFieldValue(
                                //   "manufacturerItem",
                                //   selectedOption,
                                // );

                                handleChangeManuItemForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "manufacturerItem",
                                  selectedOption,
                                );

                                formikForUpdate.setFieldValue(
                                  "manufacturerProductVariant",
                                  "",
                                );
                                getProductVariant(selectedOption?.value);
                                // Optionally: fetch product variants for this item
                              }}
                            />
                            {formikForUpdate.touched.manufacturerItem &&
                              formikForUpdate.errors.manufacturerItem && (
                                <TextError
                                  msg={formikForUpdate.errors.manufacturerItem}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Product Variant
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Product Variant"
                              name="manufacturerProductVariant"
                              options={productVariantOptions}
                              value={ProductSelectedForEdit}
                              onChange={(selectedOption) => {
                                handleChangeManuProductForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "manufacturerProductVariant",
                                  selectedOption,
                                );
                                // formikForUpdate.setFieldValue(
                                //   "manufacturerProductVariant",
                                //   selectedOption,
                                // );
                              }}
                            />
                            {formikForUpdate.touched
                              .manufacturerProductVariant &&
                              formikForUpdate.errors
                                .manufacturerProductVariant && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors
                                      .manufacturerProductVariant
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Quantity</MDTypography>
                            <MDInput
                              type="number"
                              name="QuantityUpdate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.QuantityUpdate}
                              error={
                                formikForUpdate.touched.QuantityUpdate &&
                                formikForUpdate.errors.QuantityUpdate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.QuantityUpdate &&
                              formikForUpdate.errors.QuantityUpdate && (
                                <TextError
                                  msg={formikForUpdate.errors.QuantityUpdate}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Quantity UOM{" "}
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Choose one..."
                              name="quantityUOM"
                              options={quantityUOMOptions}

                              value={
                                quantityUOMOptions?.find(
                                  (option) => option.value === formikForUpdate.values.quantityUOM
                                ) || null
                              }
                              onBlur={() =>
                                formikForUpdate.handleBlur({
                                  target: { name: "quantityUOM" },
                                })
                              }
                              onChange={(selectedOption) => {


                                formikForUpdate.setFieldValue(
                                  "quantityUOM",
                                  selectedOption ? selectedOption.value : ""
                                );
                              }}
                            // menuPortalTarget={document.body}
                            // menuPosition="fixed"
                            />
                            {formikForUpdate.touched.quantityUOM &&
                              formikForUpdate.errors.quantityUOM && (
                                <TextError
                                  msg={formikForUpdate.errors.quantityUOM}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6" ml={0.1}>
                              Actual Mass
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="ActualMass"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ActualMass}
                              error={
                                formikForUpdate.touched.ActualMass &&
                                formikForUpdate.errors.ActualMass &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ActualMass &&
                              formikForUpdate.errors.ActualMass && (
                                <TextError
                                  msg={formikForUpdate.errors.ActualMass}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        {/* <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Actual Mass UOM 
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="actualMassUOM"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.actualMassUOM}
                              error={
                                formikForUpdate.touched.actualMassUOM &&
                                formikForUpdate.errors.actualMassUOM &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.actualMassUOM &&
                              formikForUpdate.errors.actualMassUOM && (
                                <TextError
                                  msg={formikForUpdate.errors.actualMassUOM}
                                />
                              )}
                          </MDBox>
                        </Grid> */}

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Actual Mass UOM{" "}
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Choose one..."
                              name="actualMassUOM"
                              options={actualMassUOMOptions} 
                              value={
                                actualMassUOMOptions?.find(
                                  (option) =>
                                    option.value === formikForUpdate.values.actualMassUOM ||
                                    option.value === formikForUpdate.values.actualMassUOM?.value
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                formikForUpdate.setFieldValue(
                                  "actualMassUOM",
                                  selectedOption,
                                );
                              }}
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "actualMassUOM" },
                                });
                              }}
                            />
                            {formikForUpdate.touched.actualMassUOM &&
                              formikForUpdate.errors.actualMassUOM && (
                                <TextError
                                  msg={formikForUpdate.errors.actualMassUOM}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Brand Name</MDTypography>
                            <MDInput
                              type="text"
                              name="brandName"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.brandName}
                              error={
                                formikForUpdate.touched.brandName &&
                                formikForUpdate.errors.brandName &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.brandName &&
                              formikForUpdate.errors.brandName && (
                                <TextError
                                  msg={formikForUpdate.errors.brandName}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography
                              variant="h6"
                              fontWeight={500}
                              ml={0.1}
                            >
                              Brand Logo Image
                            </MDTypography>

                            <MDBox width="100%">
                              {/* Hidden file input */}
                              <input
                                id="upload-logo-update"
                                type="file"
                                accept=".png,.jpg,.jpeg"
                                hidden
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];

                                  if (!file) return;

                                  const allowedTypes = [
                                    "image/png",
                                    "image/jpeg",
                                    "image/jpg",
                                  ];

                                  if (!allowedTypes.includes(file.type)) {
                                    formikForUpdate.setFieldError(
                                      "brandLogoImage",
                                      "Only PNG, JPG, and JPEG images are allowed.",
                                    );
                                    formikForUpdate.setFieldValue(
                                      "brandLogoImage",
                                      null,
                                    );
                                    e.target.value = "";
                                    return;
                                  }

                                  formikForUpdate.setFieldError(
                                    "brandLogoImage",
                                    "",
                                  );
                                  formikForUpdate.setFieldValue(
                                    "brandLogoImage",
                                    file,
                                  );
                                }}
                              />

                              {/* Single Clickable Dashed Box */}
                              <label
                                htmlFor="upload-logo-update"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  display: "block",
                                }}
                              >
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "34px",
                                    // Conditional Light Red Border agar error hai
                                    border:
                                      formikForUpdate.touched.brandLogoImage &&
                                        formikForUpdate.errors.brandLogoImage
                                        ? "1px dashed #f87f7f"
                                        : "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": {
                                      backgroundColor: "#f8f9fa",
                                    },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={
                                      formikForUpdate.values.brandLogoImage
                                        ?.name ??
                                      singleFgDataForUpdate?.documentDetails?.find(
                                        (item) =>
                                          item.documentType ===
                                          "brandLogoImage",
                                      )?.documentName ??
                                      "Choose File"
                                    }
                                  >
                                    {formikForUpdate.values.brandLogoImage
                                      ?.name ??
                                      singleFgDataForUpdate?.documentDetails?.find(
                                        (item) =>
                                          item.documentType ===
                                          "brandLogoImage",
                                      )?.documentName ??
                                      "Choose File"}
                                  </MDTypography>

                                  {/* Edit Icon */}
                                  <Icon fontSize="small" color="info">
                                    edit
                                  </Icon>
                                </MDBox>
                              </label>

                              {/* Standard Error Display */}
                              {formikForUpdate.touched.brandLogoImage &&
                                formikForUpdate.errors.brandLogoImage && (
                                  <TextError
                                    msg={formikForUpdate.errors.brandLogoImage}
                                  />
                                )}
                            </MDBox>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Status
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              // maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={activeDataOptions}
                              value={locationSelectedForEdit}
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "location",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForUpdate.touched.location &&
                              formikForUpdate.errors.location && (
                                <TextError
                                  msg={formikForUpdate.errors.location}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Industry
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              // maxMenuHeight={70}
                              placeholder="Choose one..."
                              name="Choose one..."
                              options={IndustryOptions}
                              value={IndustrySelectedForEdit}
                              onChange={(selectedOption) => {
                                handleChangeLocationForEditForIndustry(
                                  selectedOption,
                                );
                                formikForUpdate.setFieldValue(
                                  "Industry",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForUpdate.touched.Industry &&
                              formikForUpdate.errors.Industry && (
                                <TextError
                                  msg={formikForUpdate.errors.Industry}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              GTIN Number
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="GTINNumber"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.GTINNumber}
                              error={
                                formikForUpdate.touched.GTINNumber &&
                                formikForUpdate.errors.GTINNumber &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.GTINNumber &&
                              formikForUpdate.errors.GTINNumber && (
                                <TextError
                                  msg={formikForUpdate.errors.GTINNumber}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Collection/Model Type
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="CollectionModelType"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.CollectionModelType}
                              error={
                                formikForUpdate.touched.CollectionModelType &&
                                formikForUpdate.errors.CollectionModelType &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.CollectionModelType &&
                              formikForUpdate.errors.CollectionModelType && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.CollectionModelType
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox mb={2} ml={1}>
                            <MDTypography variant="h6" fontWeight={500}>
                              Upload Product
                            </MDTypography>

                            <MDBox width="100%">
                              {/* Hidden file input */}
                              <input
                                id="upload-file"
                                type="file"
                                hidden
                                accept=".jpg,.jpeg,.png,.webp"
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];

                                  if (!file) return;

                                  const allowedTypes = [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "image/webp",
                                  ];

                                  if (!allowedTypes.includes(file.type)) {
                                    formikForUpdate.setFieldError(
                                      "file",
                                      "Only JPG, JPEG, PNG, and WEBP images are allowed.",
                                    );
                                    formikForUpdate.setFieldValue("file", null);
                                    e.target.value = "";
                                    return;
                                  }

                                  formikForUpdate.setFieldError("file", "");
                                  formikForUpdate.setFieldValue("file", file);
                                }}
                              />

                              {/* Single Clickable Dashed Box */}
                              <label
                                htmlFor="upload-file"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  display: "block",
                                }}
                              >
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "34px",
                                    // Conditional Light Red Border agar error hai
                                    border:
                                      formikForUpdate.touched.file &&
                                        formikForUpdate.errors.file
                                        ? "1px dashed #f87f7f"
                                        : "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": {
                                      backgroundColor: "#f8f9fa",
                                    },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={
                                      formikForUpdate.values.file?.name ??
                                      singleFgDataForUpdate?.documentDetails?.find(
                                        (item) =>
                                          item.documentType === "productImage",
                                      )?.documentName ??
                                      "Choose File"
                                    }
                                  >
                                    {formikForUpdate.values.file?.name ??
                                      singleFgDataForUpdate?.documentDetails?.find(
                                        (item) =>
                                          item.documentType === "productImage",
                                      )?.documentName ??
                                      "Choose File"}
                                  </MDTypography>
                                  <Icon fontSize="small" color="info">
                                    edit
                                  </Icon>
                                </MDBox>
                              </label>

                              {formikForUpdate.touched.file &&
                                formikForUpdate.errors.file && (
                                  <TextError
                                    msg={formikForUpdate.errors.file}
                                  />
                                )}
                            </MDBox>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              CE Marking{" "}
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              placeholder="Select Yes/No..."
                              name="ceMarking"
                              options={ceMarkingOptions}
                              value={
                                ceMarkingOptions?.find(
                                  (option) =>
                                    option.value ===
                                    formikForUpdate.values.ceMarking,
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                const selectedVal = selectedOption
                                  ? selectedOption.value
                                  : "";
                                formikForUpdate.setFieldValue(
                                  "ceMarking",
                                  selectedVal,
                                );

                                if (
                                  !selectedOption ||
                                  selectedVal === 0 ||
                                  selectedVal === "0"
                                ) {
                                  formikForUpdate.setFieldValue(
                                    "ceCertificate",
                                    null,
                                  );
                                }
                              }}
                              onBlur={() => {
                                formikForUpdate.setFieldTouched(
                                  "ceMarking",
                                  true,
                                );
                              }}
                            />
                            {formikForUpdate.touched.ceMarking &&
                              formikForUpdate.errors.ceMarking && (
                                <TextError
                                  msg={formikForUpdate.errors.ceMarking}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {(formikForUpdate.values.ceMarking === 1 ||
                          formikForUpdate.values.ceMarking === "1") && (
                            <Grid item xs={12} lg={4} mt={0}>
                              <MDBox mb={2} ml={1}>
                                <MDTypography variant="h6" fontWeight={500}>
                                  CE Certificate
                                </MDTypography>

                                <MDBox width="100%">
                                  <input
                                    id="edit-upload-ce-certificate"
                                    type="file"
                                    hidden
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    onChange={(e) => {
                                      const file = e.currentTarget.files[0];
                                      if (!file) return;

                                      const allowedTypes = [
                                        "image/jpeg",
                                        "image/jpg",
                                        "image/png",
                                        "application/pdf",
                                      ];

                                      if (!allowedTypes.includes(file.type)) {
                                        formikForUpdate.setFieldError(
                                          "ceCertificate",
                                          "Only JPG, JPEG, PNG, and PDF files are allowed.",
                                        );
                                        formikForUpdate.setFieldValue(
                                          "ceCertificate",
                                          null,
                                        );
                                        e.target.value = "";
                                        return;
                                      }

                                      formikForUpdate.setFieldError(
                                        "ceCertificate",
                                        "",
                                      );
                                      formikForUpdate.setFieldValue(
                                        "ceCertificate",
                                        file,
                                      );
                                    }}
                                  />

                                  {!formikForUpdate.values.ceCertificate &&
                                    !singleFgDataForUpdate?.ceCertificateName ? (
                                    <label
                                      htmlFor="edit-upload-ce-certificate"
                                      style={{ display: "block", width: "100%" }}
                                    >
                                      <MDButton
                                        variant="outlined"
                                        component="span"
                                        color="info"
                                        fullWidth
                                        sx={{
                                          height: "34px",
                                          minHeight: "34px",
                                          maxHeight: "34px",
                                          padding: "4px 16px",
                                          boxSizing: "border-box",
                                          fontSize: "0.85rem",
                                          borderColor:
                                            formikForUpdate.touched
                                              .ceCertificate &&
                                              formikForUpdate.errors.ceCertificate
                                              ? "#f87f7f"
                                              : undefined,
                                          color:
                                            formikForUpdate.touched
                                              .ceCertificate &&
                                              formikForUpdate.errors.ceCertificate
                                              ? "#f87f7f"
                                              : undefined,
                                        }}
                                      >
                                        Choose File
                                      </MDButton>
                                    </label>
                                  ) : (
                                    <label
                                      htmlFor="edit-upload-ce-certificate"
                                      style={{
                                        width: "100%",
                                        cursor: "pointer",
                                        display: "block",
                                      }}
                                    >
                                      <MDBox
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        px={1.5}
                                        sx={{
                                          height: "34px",
                                          border:
                                            formikForUpdate.touched
                                              .ceCertificate &&
                                              formikForUpdate.errors.ceCertificate
                                              ? "1px dashed #f87f7f"
                                              : "1px dashed #1A73E8",
                                          borderRadius: "8px",
                                          backgroundColor: "#fff",
                                          boxSizing: "border-box",
                                          transition: "background-color 0.2s",
                                          "&:hover": {
                                            backgroundColor: "#f8f9fa",
                                          },
                                        }}
                                      >
                                        <MDTypography
                                          variant="body2"
                                          color="text"
                                          sx={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            flex: 1,
                                            fontSize: "14px",
                                            mr: 1,
                                          }}
                                          title={
                                            formikForUpdate.values.ceCertificate
                                              ?.name ??
                                            singleFgDataForUpdate?.ceCertificateName ??
                                            "Choose File"
                                          }
                                        >
                                          {formikForUpdate.values.ceCertificate
                                            ?.name ??
                                            singleFgDataForUpdate?.ceCertificateName ??
                                            "Choose File"}
                                        </MDTypography>

                                        <Icon fontSize="small" color="info">
                                          edit
                                        </Icon>
                                      </MDBox>
                                    </label>
                                  )}

                                  {formikForUpdate.touched.ceCertificate &&
                                    formikForUpdate.errors.ceCertificate && (
                                      <TextError
                                        msg={formikForUpdate.errors.ceCertificate}
                                      />
                                    )}
                                </MDBox>
                              </MDBox>
                            </Grid>
                          )}

                        {!hideProductImageUrl && (
                          <Grid item xs={12} lg={12}>
                            <MDBox mb={1}>
                              <MDTypography variant="h6">
                                ProductImage URL
                              </MDTypography>

                              <MDInput
                                type="text"
                                name="productImageUrl"
                                fullWidth
                                autoComplete="off"
                                onBlur={formikForUpdate.handleBlur}
                                onChange={formikForUpdate.handleChange}
                                value={formikForUpdate.values.productImageUrl}
                                error={
                                  formikForUpdate.touched.productImageUrl &&
                                  Boolean(
                                    formikForUpdate.errors.productImageUrl,
                                  )
                                }
                                inputProps={{ style: { height: "10px" } }}
                              />

                              {formikForUpdate.touched.productImageUrl &&
                                formikForUpdate.errors.productImageUrl && (
                                  <TextError
                                    msg={formikForUpdate.errors.productImageUrl}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                        )}

                        <Grid item xs={12} lg={12}>
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                          {/* <MDBox mt={3} ml={10}> */}

                          <MDButton
                            // variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </Grid>
                        {/* </MDBox> */}
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Product Passport
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3} mt={0}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <MDBox>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Type
                          </MDTypography>

                          <label
                            style={{ marginRight: "20px", fontSize: "15px" }}
                          >
                            <input
                              type="radio"
                              name="type"
                              value="parent"
                              checked={formik.values.type === "parent"}
                              // onChange={(e) =>
                              //   // formik.setFieldValue("type", e.target.value)

                              //   formik.resetForm({
                              //     values: {
                              //       ...formik.initialValues,
                              //       type: e.target.value,
                              //     },
                              //   })
                              // }

                              onChange={(e) => {
                                const selectedType = e.target.value;
                                const isActuallyDirty = Object.keys(
                                  formik.values,
                                ).some((key) => {
                                  if (key === "type") return false;
                                  return (
                                    formik.values[key] !==
                                    formik.initialValues[key]
                                  );
                                });

                                if (isActuallyDirty) {
                                  setPendingTypeChange(selectedType);
                                  setOpenTypeConfirmModal(true);
                                } else {
                                  formik.setFieldValue("type", selectedType);
                                }
                              }}
                              style={{ marginRight: "5px" }}
                            />
                            Parent
                          </label>

                          <label style={{ fontSize: "15px" }}>
                            <input
                              type="radio"
                              name="type"
                              value="child"
                              checked={formik.values.type === "child"}
                              // onChange={(e) =>
                              //   // formik.setFieldValue("type", e.target.value)
                              //   formik.resetForm({
                              //     values: {
                              //       ...formik.initialValues,
                              //       type: e.target.value,
                              //     },
                              //   })
                              // }
                              onChange={(e) => {
                                const selectedType = e.target.value;
                                const isActuallyDirty = Object.keys(
                                  formik.values,
                                ).some((key) => {
                                  if (key === "type") return false;
                                  return (
                                    formik.values[key] !==
                                    formik.initialValues[key]
                                  );
                                });

                                if (isActuallyDirty) {
                                  setPendingTypeChange(selectedType);
                                  setOpenTypeConfirmModal(true);
                                } else {
                                  formik.setFieldValue("type", selectedType);
                                }
                              }}
                              style={{ marginRight: "5px" }}
                            />
                            Child
                          </label>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Product Code{" "}
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="productCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.productCode}
                            error={
                              formik.touched.productCode &&
                              formik.errors.productCode &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.productCode &&
                            formik.errors.productCode && (
                              <TextError msg={formik.errors.productCode} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Customer Part Number */}
                      <Grid item xs={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Customer Part Number{" "}
                          </MDTypography>

                          <MDBox width="100%">
                            <MDInput
                              fullWidth
                              name="customerPartNumber"
                              // placeholder="Enter Customer Part Number"
                              value={formik.values.customerPartNumber}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                          </MDBox>

                          {formik.touched.customerPartNumber &&
                            formik.errors.customerPartNumber && (
                              <MDTypography
                                variant="caption"
                                color="error"
                                mt={0.5}
                                display="block"
                              >
                                {formik.errors.customerPartNumber}
                              </MDTypography>
                            )}
                        </MDBox>
                      </Grid>

                      {/* Casting Process */}
                      <Grid item xs={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Casting Process{" "}
                          </MDTypography>

                          <MDBox width="100%">
                            <MDInput
                              fullWidth
                              name="castingProcess"
                              // placeholder="Enter Casting Process"
                              value={formik.values.castingProcess}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                          </MDBox>

                          {formik.touched.castingProcess &&
                            formik.errors.castingProcess && (
                              <MDTypography
                                variant="caption"
                                color="error"
                                mt={0.5}
                                display="block"
                              >
                                {formik.errors.castingProcess}
                              </MDTypography>
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">version </MDTypography>
                          <MDInput
                            type="text"
                            name="version"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.version}
                            error={
                              formik.touched.version &&
                              formik.errors.version &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.version && formik.errors.version && (
                            <TextError msg={formik.errors.version} />
                          )}
                        </MDBox>
                      </Grid>

                      {/* Drawing Revision */}
                      <Grid item xs={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Drawing Revision{" "}
                          </MDTypography>

                          <MDBox width="100%">
                            <MDInput
                              fullWidth
                              name="drawingRevision"
                              // placeholder="Enter Drawing Revision"
                              value={formik.values.drawingRevision}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                          </MDBox>

                          {formik.touched.drawingRevision &&
                            formik.errors.drawingRevision && (
                              <MDTypography
                                variant="caption"
                                color="error"
                                mt={0.5}
                                display="block"
                              >
                                {formik.errors.drawingRevision}
                              </MDTypography>
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Serial Number
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="serialNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.serialNumber}
                            error={
                              formik.touched.serialNumber &&
                              formik.errors.serialNumber &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.serialNumber &&
                            formik.errors.serialNumber && (
                              <TextError msg={formik.errors.serialNumber} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Batch Number{" "}
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="batchNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.batchNumber}
                            error={
                              formik.touched.batchNumber &&
                              formik.errors.batchNumber &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.batchNumber &&
                            formik.errors.batchNumber && (
                              <TextError msg={formik.errors.batchNumber} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Material Grade */}
                      <Grid item xs={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Material Grade{" "}
                          </MDTypography>

                          <MDBox width="100%">
                            <MDInput
                              fullWidth
                              name="materialGrade"
                              // placeholder="Enter Material Grade"
                              value={formik.values.materialGrade}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                          </MDBox>

                          {formik.touched.materialGrade &&
                            formik.errors.materialGrade && (
                              <MDTypography
                                variant="caption"
                                color="error"
                                mt={0.5}
                                display="block"
                              >
                                {formik.errors.materialGrade}
                              </MDTypography>
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Description </MDTypography>
                          <MDInput
                            type="text"
                            name="Description"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Description}
                            error={
                              formik.touched.Description &&
                              formik.errors.Description &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Description &&
                            formik.errors.Description && (
                              <TextError msg={formik.errors.Description} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">DPP Code </MDTypography>
                          <MDInput
                            type="text"
                            name="dppCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.dppCode}
                            error={
                              formik.touched.dppCode &&
                              formik.errors.dppCode &&
                              true
                            }
                            disabled={true}
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}


                          />
                          {formik.touched.dppCode && formik.errors.dppCode && (
                            <div
                              style={{
                                position: "absolute",
                                right: "35px",
                                top: "33px",
                                color: "#f44336",
                                pointerEvents: "none"
                              }}
                            >
                              <Icon fontSize="small">error_outline</Icon>
                            </div>
                          )}

                          {formik.touched.dppCode && formik.errors.dppCode && (
                            <div
                              style={{
                                position: "absolute",
                                right: "35px",
                                top: "33px",
                                color: "#f44336",
                                pointerEvents: "none"
                              }}
                            >
                              <Icon fontSize="small">error_outline</Icon>
                            </div>
                          )}
                          {formik.touched.dppCode && formik.errors.dppCode && (
                            <TextError msg={formik.errors.dppCode} />
                          )}
                        </MDBox>
                      </Grid>

                      {/* Quantity Field */}
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Quantity </MDTypography>
                          <MDInput
                            type="number"
                            name="quantity"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.quantity}
                            error={
                              formik.touched.quantity &&
                              formik.errors.quantity &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                            }}
                          />
                          {formik.touched.quantity &&
                            formik.errors.quantity && (
                              <TextError msg={formik.errors.quantity} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Quantity UOM{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="quantityUOM"
                            options={quantityUOMOptions}
                            value={formik.values.quantityUOM}
                            onChange={(selectedOption) => {
                              formik.setFieldValue(
                                "quantityUOM",
                                selectedOption,
                              );
                            }}
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "quantityUOM" },
                              });
                            }}
                          // menuPortalTarget={document.body}
                          // menuPosition="fixed"

                          />
                          {formik.touched.quantityUOM &&
                            formik.errors.quantityUOM && (
                              <TextError msg={formik.errors.quantityUOM} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Actual Mass Field */}
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">Actual Mass </MDTypography>
                          <MDInput
                            type="text"
                            name="actualMass"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.actualMass}
                            error={
                              formik.touched.actualMass &&
                              formik.errors.actualMass &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                            }}
                          />
                          {formik.touched.actualMass &&
                            formik.errors.actualMass && (
                              <TextError msg={formik.errors.actualMass} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Actual Mass UOM{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="actualMassUOM"
                            options={actualMassUOMOptions}
                            value={formik.values.actualMassUOM}
                            onChange={(selectedOption) => {
                              formik.setFieldValue(
                                "actualMassUOM",
                                selectedOption,
                              );
                            }}
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "actualMassUOM" },
                              });
                            }}
                          />
                          {formik.touched.actualMassUOM &&
                            formik.errors.actualMassUOM && (
                              <TextError msg={formik.errors.actualMassUOM} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Brand Name </MDTypography>
                          <MDInput
                            type="text"
                            name="brandName"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.brandName}
                            error={
                              formik.touched.brandName &&
                              formik.errors.brandName &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.brandName &&
                            formik.errors.brandName && (
                              <TextError msg={formik.errors.brandName} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">GTIN Number</MDTypography>
                          <MDInput
                            type="number"
                            name="GTINNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.GTINNumber}
                            error={
                              formik.touched.GTINNumber &&
                              formik.errors.GTINNumber &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.GTINNumber &&
                            formik.errors.GTINNumber && (
                              <TextError msg={formik.errors.GTINNumber} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Collection/Model Type
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="CollectionModelType"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.CollectionModelType}
                            error={
                              formik.touched.CollectionModelType &&
                              formik.errors.CollectionModelType &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.CollectionModelType &&
                            formik.errors.CollectionModelType && (
                              <TextError
                                msg={formik.errors.CollectionModelType}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Upload Product Image
                          </MDTypography>

                          <MDBox width="100%">
                            <input
                              id="upload-file"
                              type="file"
                              accept=".png,.jpg,.jpeg"
                              hidden
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];

                                if (!file) return;

                                const allowedTypes = [
                                  "image/png",
                                  "image/jpeg",
                                  "image/jpg",
                                ];

                                if (!allowedTypes.includes(file.type)) {
                                  formik.setFieldError(
                                    "file",
                                    "Only PNG, JPG, and JPEG images are allowed.",
                                  );
                                  formik.setFieldValue("file", null);
                                  e.target.value = "";
                                  return;
                                }

                                formik.setFieldError("file", "");
                                formik.setFieldValue("file", file);
                              }}
                            />

                            {!formik.values.file ? (
                              <label
                                htmlFor="upload-file"
                                style={{ display: "block", width: "100%" }}
                              >
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                  fullWidth
                                  sx={{
                                    height: "34px",
                                    minHeight: "34px",
                                    maxHeight: "34px",
                                    padding: "4px 16px",
                                    boxSizing: "border-box",
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  Choose File
                                </MDButton>
                              </label>
                            ) : (
                              <label
                                htmlFor="upload-file"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  display: "block",
                                }}
                              >
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "32.5px",
                                    border: "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": {
                                      backgroundColor: "#f8f9fa",
                                    },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={formik.values.file.name}
                                  >
                                    {formik.values.file.name}
                                  </MDTypography>

                                  <Icon fontSize="small" color="info">
                                    edit
                                  </Icon>
                                </MDBox>
                              </label>
                            )}
                          </MDBox>

                          {formik.errors.file && (
                            <MDTypography
                              variant="caption"
                              color="error"
                              mt={0.5}
                              display="block"
                            >
                              {formik.errors.file}
                            </MDTypography>
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={4} mt={2}>
                        <MDBox ml={0}>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Brand Logo Image
                          </MDTypography>

                          <MDBox width="100%">
                            <input
                              id="upload-logo"
                              type="file"
                              accept=".png,.jpg,.jpeg"
                              hidden
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];

                                if (!file) return;

                                const allowedTypes = [
                                  "image/png",
                                  "image/jpeg",
                                  "image/jpg",
                                ];

                                if (!allowedTypes.includes(file.type)) {
                                  formik.setFieldError(
                                    "brandLogoImage",
                                    "Only PNG, JPG, and JPEG images are allowed.",
                                  );
                                  formik.setFieldValue("brandLogoImage", null);
                                  e.target.value = "";
                                  return;
                                }

                                formik.setFieldError("brandLogoImage", "");
                                formik.setFieldValue("brandLogoImage", file);
                              }}
                            />

                            {/* Conditional Rendering */}
                            {!formik.values.brandLogoImage ? (
                              <label
                                htmlFor="upload-logo"
                                style={{ display: "block", width: "100%" }}
                              >
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                  fullWidth
                                  sx={{
                                    height: "34px",
                                    minHeight: "34px",
                                    maxHeight: "34px",
                                    padding: "4px 16px",
                                    boxSizing: "border-box",
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  Choose File
                                </MDButton>
                              </label>
                            ) : (
                              <label
                                htmlFor="upload-logo"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  display: "block",
                                }}
                              >
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "32.5px",
                                    border: "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": {
                                      backgroundColor: "#f8f9fa",
                                    },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={formik.values.brandLogoImage.name}
                                  >
                                    {formik.values.brandLogoImage.name}
                                  </MDTypography>

                                  {/* Edit Icon */}
                                  <Icon fontSize="small" color="info">
                                    edit
                                  </Icon>
                                </MDBox>
                              </label>
                            )}
                          </MDBox>

                          {/* Validation Error Display */}
                          {formik.errors.brandLogoImage && (
                            <MDTypography
                              variant="caption"
                              color="error"
                              mt={0.5}
                              display="block"
                            >
                              {formik.errors.brandLogoImage}
                            </MDTypography>
                          )}
                        </MDBox>
                      </Grid>

                      {!hideProductImageUrl && (
                        <Grid item xs={12} lg={12}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">
                              ProductImage URL
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="productImageUrl"
                              fullWidth
                              autoComplete="off"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.productImageUrl}
                              error={
                                formik.touched.productImageUrl &&
                                formik.errors.productImageUrl &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formik.touched.productImageUrl &&
                              formik.errors.productImageUrl && (
                                <TextError
                                  msg={formik.errors.productImageUrl}
                                />
                              )}
                          </MDBox>
                        </Grid>
                      )}
                      {formik.values.type === "child" && (
                        <>
                          <Grid item xs={12} lg={4} mt={2}>
                            <MDBox mb={1} ml={1}>
                              <MDTypography
                                variant="h6"
                                style={{ fontWeight: "500" }}
                              >
                                Parent
                              </MDTypography>

                              <Select
                                isClearable
                                className="select-css"
                                // maxMenuHeight={230}
                                placeholder="Choose one..."
                                name="parent"
                                onBlur={() => {
                                  formik.handleBlur({
                                    target: { name: "parent" },
                                  });
                                }}
                                value={ParentDppIdSelected}
                                options={dppCodesOptions}
                                onChange={(selectedOption) => {
                                  handleChangeDppCodeParent(selectedOption);
                                  getParentRawCodes(selectedOption?.value);
                                  formik.setFieldValue(
                                    "parent",
                                    selectedOption,
                                  );
                                }}
                              />

                              {formik.touched.parent &&
                                formik.errors.parent && (
                                  <TextError msg={formik.errors.parent} />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4} mt={2}>
                            <MDBox ml={1}>
                              <MDTypography
                                variant="h6"
                                style={{ fontWeight: "500" }}
                              >
                                Raw Material
                              </MDTypography>

                              <Select
                                isClearable
                                className="select-css"
                                // maxMenuHeight={230}
                                placeholder="Choose one..."
                                name="child"
                                onBlur={() => {
                                  formik.handleBlur({
                                    target: { name: "child" },
                                  });
                                }}
                                value={RawDppSelected}
                                options={rawMaterialOptions}
                                onChange={(selectedOption) => {
                                  handleChangeDppCodeRaw(selectedOption);
                                  formik.setFieldValue("child", selectedOption);
                                }}
                              />

                              {formik.touched.child && formik.errors.child && (
                                <TextError msg={formik.errors.child} />
                              )}
                            </MDBox>
                          </Grid>
                        </>
                      )}

                      <Grid item xs={12} lg={12} mt={2}>
                        <MDBox>
                          {/* <MDTypography variant="h6" fontWeight={500}>
                            Manufacturer Details
                          </MDTypography> */}
                          <Grid container spacing={1}>
                            <Grid item xs={12} lg={4}>
                              <MDTypography variant="h6">
                                Manufacturer Name
                              </MDTypography>
                              <Select
                                isClearable
                                className="select-css"
                                placeholder="Choose one..."
                                name="manufacturerName"
                                options={manufacturerOptions}
                                value={formik.values.manufacturerName}
                                onChange={(selectedOption) => {
                                  formik.setFieldValue(
                                    "manufacturerName",
                                    selectedOption,
                                  );
                                  // Optionally: fetch items for this manufacturer
                                }}
                              />
                              {formik.touched.manufacturerName &&
                                formik.errors.manufacturerName && (
                                  <TextError
                                    msg={formik.errors.manufacturerName}
                                  />
                                )}
                            </Grid>
                            <Grid item xs={12} lg={4}>
                              <MDBox ml={1}>
                                <MDTypography variant="h6">
                                  Industry
                                </MDTypography>
                                <Select
                                  isClearable
                                  className="select-css"
                                  placeholder="Choose one..."
                                  name="Industry"
                                  options={IndustryOptions}
                                  value={formik.values.Industry}
                                  onChange={(selectedOption) => {
                                    formik.setFieldValue(
                                      "Industry",
                                      selectedOption,
                                    );
                                    // Optionally: fetch items for this manufacturer
                                  }}
                                />
                                {formik.touched.Industry &&
                                  formik.errors.Industry && (
                                    <TextError msg={formik.errors.Industry} />
                                  )}
                              </MDBox>
                            </Grid>
                            <Grid item xs={12} lg={4}>
                              <MDTypography variant="h6">Item</MDTypography>
                              <Select
                                isClearable
                                className="select-css"
                                placeholder="Choose one..."
                                name="manufacturerItem"
                                options={itemCodeOptions}
                                value={formik.values.manufacturerItem}
                                onChange={(selectedOption) => {
                                  formik.setFieldValue(
                                    "manufacturerItem",
                                    selectedOption,
                                  );
                                  formik.setFieldValue(
                                    "manufacturerProductVariant",
                                    "",
                                  );
                                  getProductVariant(selectedOption?.value);
                                  // Optionally: fetch product variants for this item
                                }}
                              />
                              {formik.touched.manufacturerItem &&
                                formik.errors.manufacturerItem && (
                                  <TextError
                                    msg={formik.errors.manufacturerItem}
                                  />
                                )}
                            </Grid>
                          </Grid>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2} mb={1}>
                        <MDTypography variant="h6">
                          Product Variant
                        </MDTypography>
                        <Select
                          isClearable
                          className="select-css"
                          placeholder="Choose one..."
                          name="manufacturerProductVariant"
                          options={productVariantOptions}
                          value={formik.values.manufacturerProductVariant}
                          onChange={(selectedOption) => {
                            formik.setFieldValue(
                              "manufacturerProductVariant",
                              selectedOption,
                            );
                          }}
                        />
                        {formik.touched.manufacturerProductVariant &&
                          formik.errors.manufacturerProductVariant && (
                            <TextError
                              msg={formik.errors.manufacturerProductVariant}
                            />
                          )}
                      </Grid>

                      {/* <Grid item xs={12} lg={6}>
                        <MDBox mb={1} mr={1}>
                          <MDTypography variant="h6">Location</MDTypography>
                          <MDInput
                            type="text"
                            name="Location"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Location}
                            error={
                              formik.touched.Location &&
                              formik.errors.Location &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.Location &&
                            formik.errors.Location && (
                              <TextError msg={formik.errors.Location} />
                            )}
                        </MDBox>
                      </Grid> */}

                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Status{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            // maxMenuHeight={80}
                            placeholder="Choose one..."
                            name="status"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "status" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={activeDataOptions}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("status", selectedOption);
                            }}
                          />
                          {formik.touched.status && formik.errors.status && (
                            <TextError msg={formik.errors.status} />
                          )}
                        </MDBox>
                      </Grid>

                      {formik.values.type === "parent" && (
                        <>
                          <Grid item xs={12} lg={6} mt={1}>
                            <MDBox ml={0} mb={1}>
                              <MDTypography variant="h6">
                                CE Marking{" "}
                              </MDTypography>
                              <Select
                                isClearable
                                className="select-css"
                                placeholder="Select Yes/No..."
                                name="ceMarking"
                                options={ceMarkingOptions}
                                value={
                                  ceMarkingOptions?.find(
                                    (option) =>
                                      option.value === formik.values.ceMarking,
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  const selectedVal = selectedOption
                                    ? selectedOption.value
                                    : "";
                                  formik.setFieldValue(
                                    "ceMarking",
                                    selectedVal,
                                  );

                                  if (
                                    !selectedOption ||
                                    selectedVal === 0 ||
                                    selectedVal === "0"
                                  ) {
                                    formik.setFieldValue("ceCertificate", null);
                                  }
                                }}
                                onBlur={() => {
                                  formik.setFieldTouched("ceMarking", true);
                                }}
                              />
                              {formik.touched.ceMarking &&
                                formik.errors.ceMarking && (
                                  <TextError msg={formik.errors.ceMarking} />
                                )}
                            </MDBox>
                          </Grid>

                          {(formik.values.ceMarking === 1 ||
                            formik.values.ceMarking === "1") && (
                              <Grid item xs={12} lg={6} mt={1}>
                                <MDBox mb={2} ml={1}>
                                  <MDTypography variant="h6" fontWeight={500}>
                                    CE Certificate
                                  </MDTypography>

                                  <MDBox width="100%">
                                    <input
                                      id="upload-ce-certificate"
                                      type="file"
                                      hidden
                                      accept=".jpg,.jpeg,.png,.pdf"
                                      onChange={(e) => {
                                        const file = e.currentTarget.files[0];
                                        if (!file) return;

                                        const allowedTypes = [
                                          "image/jpeg",
                                          "image/jpg",
                                          "image/png",
                                          "application/pdf",
                                        ];

                                        if (!allowedTypes.includes(file.type)) {
                                          formik.setFieldError(
                                            "ceCertificate",
                                            "Only JPG, JPEG, PNG, and PDF files are allowed.",
                                          );
                                          formik.setFieldValue(
                                            "ceCertificate",
                                            null,
                                          );
                                          e.target.value = "";
                                          return;
                                        }

                                        formik.setFieldError("ceCertificate", "");
                                        formik.setFieldValue(
                                          "ceCertificate",
                                          file,
                                        );
                                      }}
                                    />

                                    {!formik.values.ceCertificate ? (
                                      <label
                                        htmlFor="upload-ce-certificate"
                                        style={{
                                          display: "block",
                                          width: "100%",
                                        }}
                                      >
                                        <MDButton
                                          variant="outlined"
                                          component="span"
                                          color="info"
                                          fullWidth
                                          sx={{
                                            height: "34px",
                                            minHeight: "34px",
                                            maxHeight: "34px",
                                            padding: "4px 16px",
                                            boxSizing: "border-box",
                                            fontSize: "0.85rem",
                                            borderColor:
                                              formik.touched.ceCertificate &&
                                                formik.errors.ceCertificate
                                                ? "#f87f7f"
                                                : undefined,
                                            color:
                                              formik.touched.ceCertificate &&
                                                formik.errors.ceCertificate
                                                ? "#f87f7f"
                                                : undefined,
                                          }}
                                        >
                                          Choose File
                                        </MDButton>
                                      </label>
                                    ) : (
                                      <label
                                        htmlFor="upload-ce-certificate"
                                        style={{
                                          width: "100%",
                                          cursor: "pointer",
                                          display: "block",
                                        }}
                                      >
                                        <MDBox
                                          display="flex"
                                          justifyContent="space-between"
                                          alignItems="center"
                                          px={1.5}
                                          sx={{
                                            height: "34px",
                                            border:
                                              formik.touched.ceCertificate &&
                                                formik.errors.ceCertificate
                                                ? "1px dashed #f87f7f"
                                                : "1px dashed #1A73E8",
                                            borderRadius: "8px",
                                            backgroundColor: "#fff",
                                            boxSizing: "border-box",
                                            transition: "background-color 0.2s",
                                            "&:hover": {
                                              backgroundColor: "#f8f9fa",
                                            },
                                          }}
                                        >
                                          <MDTypography
                                            variant="body2"
                                            color="text"
                                            sx={{
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              flex: 1,
                                              fontSize: "14px",
                                              mr: 1,
                                            }}
                                            title={
                                              formik.values.ceCertificate?.name
                                            }
                                          >
                                            {formik.values.ceCertificate?.name}
                                          </MDTypography>

                                          <Icon fontSize="small" color="info">
                                            edit
                                          </Icon>
                                        </MDBox>
                                      </label>
                                    )}

                                    {formik.touched.ceCertificate &&
                                      formik.errors.ceCertificate && (
                                        <TextError
                                          msg={formik.errors.ceCertificate}
                                        />
                                      )}
                                  </MDBox>
                                </MDBox>
                              </Grid>
                            )}
                        </>
                      )}

                      {/* <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Warehouse Code{" "}
                          </MDTypography>

                          <Select
                            isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="warehouseCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "warehouseCode" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={warehouseOptionsByMovement}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "warehouseCode",
                                selectedOption
                              );
                              getLevel1ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel2ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel3ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel4ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                            }}
                          />
                          {formik.touched.warehouseCode &&
                            formik.errors.warehouseCode && (
                              <TextError msg={formik.errors.warehouseCode} />
                            )}
                        </MDBox>
                      </Grid> */}

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* <Grid item xs={12}> */}
                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        type="submit"
                        fullWidth
                        // disabled={allocateButtonName === "Please wait..."}

                        disabled={
                          allocateButtonName === "Please wait..." ||
                          !(formik.isValid && formik.dirty)
                        }
                      >
                        {allocateButtonName}
                      </MDButton>

                      {/* </Grid> */}
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            <Modal
              open={openPSModal}
              onClose={handleClosePSModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: { xs: 350, lg: 1100 },
                  maxHeight: "90vh",
                  overflowY: "auto",
                  boxShadow: 24,
                  p: 0,
                  pt: 2,
                }}
              >
                <MDBox ml={3} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Product Specification
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                        aria-label="close"
                        color="inherit"
                        onClick={handleClosePSModal}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikPS.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Rated Capacity{" "}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="ratedCapacity"
                            fullWidth
                            autoComplete="off"
                            value={formikPS.values.ratedCapacity}
                            onChange={formikPS.handleChange}
                            onBlur={formikPS.handleBlur}
                            error={
                              formikPS.touched.ratedCapacity &&
                              Boolean(formikPS.errors.ratedCapacity)
                            }
                            sx={{
                              "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#f87f7f !important",
                              },
                              "& .MuiInputBase-root.Mui-error::after": {
                                borderBottomColor: "#f38b8b !important",
                              },
                            }}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formikPS.touched.ratedCapacity &&
                            formikPS.errors.ratedCapacity &&
                            formikPS.values.ratedCapacity !== "" && (
                              <TextError msg={formikPS.errors.ratedCapacity} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Rated Capacity Unit{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="ratedCapacityUnit"
                            options={ratedCapacityUnitOptions}
                            value={formikPS.values.ratedCapacityUnit}
                            onBlur={() =>
                              formikPS.handleBlur({
                                target: { name: "ratedCapacityUnit" },
                              })
                            }
                            onChange={(option) =>
                              formikPS.setFieldValue(
                                "ratedCapacityUnit",
                                option,
                              )
                            }
                          />
                          {formikPS.touched.ratedCapacityUnit &&
                            formikPS.errors.ratedCapacityUnit && (
                              <TextError
                                msg={formikPS.errors.ratedCapacityUnit}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Nominal Voltage{" "}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="nominalVoltage"
                            fullWidth
                            autoComplete="off"
                            value={formikPS.values.nominalVoltage}
                            onChange={formikPS.handleChange}
                            onBlur={formikPS.handleBlur}
                            error={
                              formikPS.touched.nominalVoltage &&
                              Boolean(formikPS.errors.nominalVoltage)
                            }
                            sx={{
                              "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#f87f7f !important",
                              },
                              "& .MuiInputBase-root.Mui-error::after": {
                                borderBottomColor: "#f38b8b !important",
                              },
                            }}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formikPS.touched.nominalVoltage &&
                            formikPS.errors.nominalVoltage &&
                            formikPS.values.nominalVoltage !== "" && (
                              <TextError msg={formikPS.errors.nominalVoltage} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Nominal Voltage Unit{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="nominalVoltageUnit"
                            options={nominalVoltageUnitOptions}
                            value={formikPS.values.nominalVoltageUnit}
                            onBlur={() =>
                              formikPS.handleBlur({
                                target: { name: "nominalVoltageUnit" },
                              })
                            }
                            onChange={(option) =>
                              formikPS.setFieldValue(
                                "nominalVoltageUnit",
                                option,
                              )
                            }
                          />
                          {formikPS.touched.nominalVoltageUnit &&
                            formikPS.errors.nominalVoltageUnit && (
                              <TextError
                                msg={formikPS.errors.nominalVoltageUnit}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Power Rating{" "}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="powerRating"
                            fullWidth
                            autoComplete="off"
                            value={formikPS.values.powerRating}
                            onChange={formikPS.handleChange}
                            onBlur={formikPS.handleBlur}
                            error={
                              formikPS.touched.powerRating &&
                              Boolean(formikPS.errors.powerRating)
                            }
                            sx={{
                              "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#f87f7f !important",
                              },
                              "& .MuiInputBase-root.Mui-error::after": {
                                borderBottomColor: "#f38b8b !important",
                              },
                            }}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formikPS.touched.powerRating &&
                            formikPS.errors.powerRating &&
                            formikPS.values.powerRating !== "" && (
                              <TextError msg={formikPS.errors.powerRating} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Power Rating Unit{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="powerRatingUnit"
                            options={powerRatingUnitOptions}
                            value={formikPS.values.powerRatingUnit}
                            onBlur={() =>
                              formikPS.handleBlur({
                                target: { name: "powerRatingUnit" },
                              })
                            }
                            onChange={(option) =>
                              formikPS.setFieldValue("powerRatingUnit", option)
                            }
                          />
                          {formikPS.touched.powerRatingUnit &&
                            formikPS.errors.powerRatingUnit && (
                              <TextError
                                msg={formikPS.errors.powerRatingUnit}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Energy Density{" "}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="energyDensity"
                            fullWidth
                            autoComplete="off"
                            value={formikPS.values.energyDensity}
                            onChange={formikPS.handleChange}
                            onBlur={formikPS.handleBlur}
                            error={
                              formikPS.touched.energyDensity &&
                              Boolean(formikPS.errors.energyDensity)
                            }
                            sx={{
                              "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#f87f7f !important",
                              },
                              "& .MuiInputBase-root.Mui-error::after": {
                                borderBottomColor: "#f38b8b !important",
                              },
                            }}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formikPS.touched.energyDensity &&
                            formikPS.errors.energyDensity &&
                            formikPS.values.energyDensity !== "" && (
                              <TextError msg={formikPS.errors.energyDensity} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Energy Density Unit{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="energyDensityUnit"
                            options={energyDensityUnitOptions}
                            value={formikPS.values.energyDensityUnit}
                            onBlur={() =>
                              formikPS.handleBlur({
                                target: { name: "energyDensityUnit" },
                              })
                            }
                            onChange={(option) =>
                              formikPS.setFieldValue(
                                "energyDensityUnit",
                                option,
                              )
                            }
                          />
                          {formikPS.touched.energyDensityUnit &&
                            formikPS.errors.energyDensityUnit && (
                              <TextError
                                msg={formikPS.errors.energyDensityUnit}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Battery Chemistry{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="batteryChemistry"
                            options={batteryChemistryOptions}
                            value={formikPS.values.batteryChemistry}
                            onBlur={() =>
                              formikPS.handleBlur({
                                target: { name: "batteryChemistry" },
                              })
                            }
                            onChange={(option) =>
                              formikPS.setFieldValue("batteryChemistry", option)
                            }
                          />
                          {formikPS.touched.batteryChemistry &&
                            formikPS.errors.batteryChemistry && (
                              <TextError
                                msg={formikPS.errors.batteryChemistry}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">Cell Format </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="batteryCellFormat"
                            options={batteryCellFormatOptions}
                            value={formikPS.values.batteryCellFormat}
                            onBlur={() =>
                              formikPS.handleBlur({
                                target: { name: "batteryCellFormat" },
                              })
                            }
                            onChange={(option) =>
                              formikPS.setFieldValue(
                                "batteryCellFormat",
                                option,
                              )
                            }
                          />
                          {formikPS.touched.batteryCellFormat &&
                            formikPS.errors.batteryCellFormat && (
                              <TextError
                                msg={formikPS.errors.batteryCellFormat}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Dimension Length{" "}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="dimensionLength"
                            fullWidth
                            autoComplete="off"
                            value={formikPS.values.dimensionLength}
                            onChange={formikPS.handleChange}
                            onBlur={formikPS.handleBlur}
                            error={
                              formikPS.touched.dimensionLength &&
                              Boolean(formikPS.errors.dimensionLength)
                            }
                            sx={{
                              "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#f87f7f !important",
                              },
                              "& .MuiInputBase-root.Mui-error::after": {
                                borderBottomColor: "#f38b8b !important",
                              },
                            }}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formikPS.touched.dimensionLength &&
                            formikPS.errors.dimensionLength &&
                            formikPS.values.dimensionLength !== "" && (
                              <TextError
                                msg={formikPS.errors.dimensionLength}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Dimension Width{" "}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="dimensionWidth"
                            fullWidth
                            autoComplete="off"
                            value={formikPS.values.dimensionWidth}
                            onChange={formikPS.handleChange}
                            onBlur={formikPS.handleBlur}
                            error={
                              formikPS.touched.dimensionWidth &&
                              Boolean(formikPS.errors.dimensionWidth)
                            }
                            sx={{
                              "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#f87f7f !important",
                              },
                              "& .MuiInputBase-root.Mui-error::after": {
                                borderBottomColor: "#f38b8b !important",
                              },
                            }}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formikPS.touched.dimensionWidth &&
                            formikPS.errors.dimensionWidth &&
                            formikPS.values.dimensionWidth !== "" && (
                              <TextError msg={formikPS.errors.dimensionWidth} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Dimension Height{" "}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="dimensionHeight"
                            fullWidth
                            autoComplete="off"
                            value={formikPS.values.dimensionHeight}
                            onChange={formikPS.handleChange}
                            onBlur={formikPS.handleBlur}
                            error={
                              formikPS.touched.dimensionHeight &&
                              Boolean(formikPS.errors.dimensionHeight)
                            }
                            sx={{
                              "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#f87f7f !important",
                              },
                              "& .MuiInputBase-root.Mui-error::after": {
                                borderBottomColor: "#f38b8b !important",
                              },
                            }}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formikPS.touched.dimensionHeight &&
                            formikPS.errors.dimensionHeight &&
                            formikPS.values.dimensionHeight !== "" && (
                              <TextError
                                msg={formikPS.errors.dimensionHeight}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Dimensions Unit{" "}
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="batteryDimensionsUnit"
                            options={batteryDimensionsUnitOptions}
                            value={formikPS.values.batteryDimensionsUnit}
                            onBlur={() =>
                              formikPS.handleBlur({
                                target: { name: "batteryDimensionsUnit" },
                              })
                            }
                            onChange={(option) =>
                              formikPS.setFieldValue(
                                "batteryDimensionsUnit",
                                option,
                              )
                            }
                          />
                          {formikPS.touched.batteryDimensionsUnit &&
                            formikPS.errors.batteryDimensionsUnit && (
                              <TextError
                                msg={formikPS.errors.batteryDimensionsUnit}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} mt={2}>
                        <Collapse in={isErrorAllocateItemPS}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItemPS(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>

                        <Collapse in={isSuccessAllocateItemPS}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItemPS(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Submitted Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      <Grid item xs={12}>
                        <MDButton
                          color="info"
                          type="submit"
                          fullWidth
                          disabled={
                            allocateButtonNamePS === "Please wait..." ||
                            !(formikPS.isValid && formikPS.dirty)
                          }
                        >
                          {allocateButtonNamePS || "Submit Specifications"}
                        </MDButton>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            <Modal
              open={psViewModal}
              onClose={handleClosePsViewModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForStationModal}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Product Specification Details
                  </MDTypography>

                  <MDBox display="flex" marginLeft="auto">
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            display: "flex",
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "auto",
                            marginBottom: "5px",
                            marginRight: "10px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleClosePsViewModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginBottom: "1rem" }} />
                <MDBox>
                  {!loadingPS ? (
                    <DataTable
                      table={{ columns: psColumns, rows: psRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        marginBottom: "100px",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )}
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getPassPortReducer: state.getPassPortReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    getParentDppCodesReducer: state.getParentDppCodesReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDppDocumentsImageReducer: state.getDppDocumentsImageReducer,
    getParentRawCodesReducer: state.getParentRawCodesReducer,
    getPassPortViewReducer: state.getPassPortViewReducer,
    getProductVariantReducer: state.getProductVariantReducer,
    getManufacturerDetailsReducer: state.getManufacturerDetailsReducer,
    getIndustryTypeReducer: state.getIndustryTypeReducer,
    getSupplierTypeReducer: state.getSupplierTypeReducer,
    getProductSpecificationReducer: state.getProductSpecificationReducer,
    getDPPReducer: state.getDPPReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getIndustryType: (jwtToken) => dispatch(getIndustryType(jwtToken)),
    getPassPort: (dppId, jwtToken) => dispatch(getPassPort(dppId, jwtToken)),
    getParentRawCodes: (dppId, jwtToken) =>
      dispatch(getParentRawCodes(dppId, jwtToken)),
    getViewDataByDppId: (dppId, jwtToken) =>
      dispatch(getViewDataByDppId(dppId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getParentDppCode: (jwtToken) => dispatch(getParentDppCode(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createPassPort: (payload, jwtToken) =>
      dispatch(createPassPort(payload, jwtToken)),
    deletePassport: (dppId, userId, jwtToken) =>
      dispatch(deletePassport(dppId, userId, jwtToken)),
    uploadCsvForItemMapping: (payload, jwtToken) =>
      dispatch(uploadCsvForItemMapping(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editPassport: (payload, jwtToken) =>
      dispatch(editPassport(payload, jwtToken)),
    uploadForUrl: (payload, jwtToken) =>
      dispatch(uploadForUrl(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),

    getDppDocumentsImage: (moduleName, type, name, jwtToken) =>
      dispatch(getDppDocumentsImage(moduleName, type, name, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
    // Add newly created 3 APIs here
    getManufacturerDetails: (payload, jwtToken) =>
      dispatch(getManufacturerDetails(payload, jwtToken)),
    getProductVariant: (payload, jwtToken) =>
      dispatch(getProductVariant(payload, jwtToken)),
    createProductSpec: (payload, jwtToken) =>
      dispatch(createProductSpec(payload, jwtToken)),
    getProductSpecification: (payload, jwtToken) =>
      dispatch(getProductSpecification(payload, jwtToken)),
    uploadCsvForPassport: (payload, jwtToken) =>
      dispatch(uploadCsvForPassport(payload, jwtToken)),

    uploadCsvForProductPassportChild: (payload, jwtToken) =>
      dispatch(uploadCsvForProductPassportChild(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Passport);
